import React, { useState, useRef, useEffect, useImperativeHandle, forwardRef } from 'react';
import {
  Button,
  FormControlLabel,
  IconButton,
  InputAdornment,
  Link,
  Radio,
  RadioGroup,
  TextField,
  Tooltip,
} from '@material-ui/core';
import InfoIcon from '@mui/icons-material/Info';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import CloseIcon from '@mui/icons-material/Close';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { Select, MenuItem } from '@material-ui/core';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import FormatBoldIcon from '@mui/icons-material/FormatBold';
import FormatItalicIcon from '@mui/icons-material/FormatItalic';
import FormatUnderlinedIcon from '@mui/icons-material/FormatUnderlined';
import StrikethroughSIcon from '@mui/icons-material/StrikethroughS';
import { v4 as uuidv4 } from 'uuid';
import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';
import FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter';
import FormatAlignRightIcon from '@mui/icons-material/FormatAlignRight';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import AttachmentIcon from '@mui/icons-material/Attachment';
import fitIcon from '../../../../assets/img/Fit.svg';
import fillIcon from '../../../../assets/img/Fill.svg';
import Linked from '../../../../assets/img/Linked.svg';
import fixedIcon from '../../../../assets/img/Fixed.svg';
import video_placeholder from '../../../../assets/img/video_placeholder.svg';
import image_placeholder from '../../../../assets/img/image_placeholder.svg';
import leftIcon from '../../../../assets/img/Left.svg';
import centerIcon from '../../../../assets/img/Center.svg';
import rightIcon from '../../../../assets/img/Right.svg';
import addIcon from '../../../../assets/img/Add.svg';
import componentsIcon from '../../../../assets/img/Components.svg';
import bodyIcon from '../../../../assets/img/Body.svg';
import headingIcon from '../../../../assets/img/Heading.svg';
import headingDragIcon from '../../../../assets/img/Heading_drag.svg';
import textIcon from '../../../../assets/img/Text.svg';
import textDragIcon from '../../../../assets/img/Text_drag.svg';
import imageIcon from '../../../../assets/img/Image.svg';
import imageDragIcon from '../../../../assets/img/Image_drag.svg';
import videoIcon from '../../../../assets/img/Video.svg';
import videoDragIcon from '../../../../assets/img/Video_drag.svg';
import dragIcon from '../../../../assets/img/Drag.svg';
import { useDispatch } from 'react-redux';
import { stepUpLoaderCount, stepDownLoaderCount } from '../../../../utils/loaderSlice';
import './Message-Create-View.scss';
import { HEADING_SIZES } from '../../../../constants/WelcomeMessageConst';
import CustomTextField from '../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import VariableKeywordsModal from './VariableKeywordsModal';
import { CloseFullscreen } from '@mui/icons-material';
import CustomSelect from '../../../../shared/form-controls/custom-select/Custom-Select';
import { getWelcomeMessageVariables } from '../../../../utils/ServicesAPIUtils';
import { ASSET_URL, PROPERTY_SERVICE_URL } from '../../../../env/Configurations';
import { getPreSignedUrl } from '../../../../utils/PropertyAPIUtils';
import { useSelector } from 'react-redux';
import { selectedGroupSelector } from '../../../property/propertySlice';
import CustomColorPicker from '../../../../shared/form-controls/custom-color-picker/CustomColorPicker';
import { isAllowedVideoUrl, isAllowedExternalUrl, VIDEO_URL_ERROR_MSG, INVALID_URL_ERROR_MSG } from '../../../../utils/urlValidationUtils';
import {
  abortMultipartUpload,
  calculateFileChecksum,
  calculateTotalChunks,
  CHUNK_SIZE,
  completeMultipartUpload,
  convertFileToBase64,
} from '../../../../utils/commonUtils';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import FormControl from '@material-ui/core/FormControl';
import { Modal } from '@material-ui/core';

const PALETTE = [
  { type: 'heading', icon: headingIcon, label: 'Heading' },
  { type: 'text', icon: textIcon, label: 'Text' },
  { type: 'image', icon: imageIcon, label: 'Image' },
  { type: 'video', icon: videoIcon, label: 'Video' },
];

const DEFAULT_PROPS = {
  heading: {
    text: 'Heading',
    isPlaceholder: true,
    level: 1,
    color: '#000000',
    fontSize: 48,
    fontFamily: '',
    fontWeight: '',
    fontStyle: 'normal',
    textDecoration: '',
    textAlign: 'left',
    padding: 0,
    paddingAllSides: false,
    letterSpacing: 0,
    listStyleType: 'none',
    width: 200,
    height: 50,
  },
  text: {
    text: 'Paragraph text',
    isPlaceholder: true,
    color: '#333333',
    fontSize: 16,
    fontFamily: '',
    fontWeight: '',
    fontStyle: 'normal',
    textDecoration: '',
    textAlign: 'left',
    padding: 8,
    letterSpacing: 0,
    listStyleType: 'none',
    width: 200,
    height: 50,
  },
  image: {
    src: '',
    s3_ImageUrl: '',
    padding: 8,
    mode: 'fit',
    containerHeight: 150,
    align: 'center',
    bgColor: 'transparent',
    width: 150,
    height: 100,
  },
  video: {
    src: '',
    width: 200,
    height: 150,
    padding: 8,
    playback: '',
    thumbnail: '',
    isPlaying: false,
    loopType: 'always',
    loopCount: 1,
    videoList: [],
    sequenceMode: 'oneTime',
    currentIndex: 0,
  },
};

const DRAG_ICONS = {
  heading: headingDragIcon,
  text: textDragIcon,
  image: imageDragIcon,
  video: videoDragIcon,
};

const getYouTubeVideoId = (url) => {
  if (!url) return null;
  try {
    const urlObj = new URL(url);
    const hostname = urlObj.hostname.replace('www.', '').replace('m.', '');
    if (hostname === 'youtu.be') {
      return urlObj.pathname.split('/')[1] || null;
    }
    if (hostname === 'youtube.com') {
      if (urlObj.searchParams.has('v')) {
        return urlObj.searchParams.get('v');
      }
      const pathMatch = urlObj.pathname.match(/^\/(embed|v|shorts|live)\/([^/?]+)/);
      if (pathMatch) return pathMatch[2];
    }
  } catch (e) {
    const match = url.match(
      /(?:youtube\.com\/(?:watch\?.*v=|embed\/|v\/|shorts\/|live\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/,
    );
    return match ? match[1] : null;
  }
  return null;
};

const FONT_FAMILIES = ['Roboto', 'Open Sans', 'Arial', 'Corbel', 'Times New Roman'];
const FONT_WEIGHTS = ['Regular', 'Medium', 'Semi bold', 'Bold'];
const FONT_SIZES = [18, 24, 32, 48];

const FONT_SIZE_TO_HEADING = {
  48: 1,
  32: 2,
  24: 3,
  18: 4,
};

const HEADING_TO_FONT_SIZE = {
  1: 48,
  2: 32,
  3: 24,
  4: 18,
};

const getFontWeightValue = (weight) => {
  const weightMap = {
    Regular: '400',
    Medium: '500',
    'Semi bold': '600',
    Bold: '700',
  };
  return weightMap[weight] || '400';
};

const WelcomeMessageTemplate = forwardRef(function WelcomeMessageTemplate(
  {
    formData,
    handleInputChange,
    onNextClick,
    isTabInValid,
    onTemplateChange,
    onTemplateSave,
    isReadOnly,
    templateEditing,
    setTemplateEditing,
    isViewMode,
    isCreate,
  },
  ref,
) {
  const [activeTab, setActiveTab] = useState(isCreate ? 'body' : 'components');
  const [canvasItems, setCanvasItems] = useState([]);
  const [showMultipleVideosWarning, setShowMultipleVideosWarning] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [toolbarCollapsed, setToolbarCollapsed] = useState(false);
  const [showVariableList, setShowVariableList] = useState(false);
  const [bodySettings, setBodySettings] = useState({
    backgroundImage: null,
    backgroundVideo: '',
    textColor: '#000000',
    fontFamily: 'Roboto',
    fontWeight: 'Regular',
  });
  const [bgFileError, setBgFileError] = useState(null);
  const canvasRef = useRef(null);
  const selectedGroup = useSelector(selectedGroupSelector);
  const inlineToolbarRef = useRef(null);
  const [showVariableDropdown, setShowVariableDropdown] = useState(false);
  const [variableDropdownPosition, setVariableDropdownPosition] = useState({ x: 0, y: 0 });
  const [variables, setVariables] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const [fileError, setFileError] = useState(null);
  const dispatch = useDispatch();
  useEffect(() => {
    if (formData?.template?.value) {
      const template = formData.template.value;
      setBodySettings({
        backgroundImage: template.templateBody.background,
        backgroundVideo: template.templateBody.bgVideoUrl,
        backgroundColor: template.templateBody.bgColor,
        textColor: template.templateBody.textColor,
        fontFamily: template.templateBody.fontFamily,
        fontWeight: template.templateBody.fontWeight,
      });
      setCanvasItems(
        template.templateComponent.map((item) => {
          const props = getProps(item);
          const type = item.type.toLowerCase();
          const textDecoration = [
            props.underline ? 'underline' : '',
            props.strikethrough ? 'line-through' : '',
          ]
            .filter(Boolean)
            .join(' ');
          const fontWeight = props.bold ? 'Bold' : 'Regular';
          const fontStyle = props.italic ? 'italic' : 'normal';
          const x = parseInt(item.xCoord, 10);
          const y = parseInt(item.yCoord, 10);
          if (type === 'heading') {
            return {
              id: uuidv4(),
              type,
              x,
              y,
              props: {
                ...props,
                fontWeight,
                fontStyle,
                textDecoration,
                color: props.textColor,
                listStyleType:
                  props.listStyleType ??
                  (props.isBullet ? 'disc' : props.isNumbered ? 'decimal' : 'none'),
                level: parseInt(props.headingTag.replace('H', ''), 10),
                fontSize: parseInt(props.fontSize.replace('px', ''), 10),
                headingType: props.headingTag,
                paddingTop: parseInt(props.padding.top.replace('px', ''), 10),
                paddingBottom: parseInt(props.padding.bottom.replace('px', ''), 10),
                paddingLeft: parseInt(props.padding.left.replace('px', ''), 10),
                paddingRight: parseInt(props.padding.right.replace('px', ''), 10),
                paddingAllSides: props.paddingAllSides ?? false,
                padding: Math.max(
                  parseInt(props.padding.top.replace('px', ''), 10),
                  parseInt(props.padding.bottom.replace('px', ''), 10),
                  parseInt(props.padding.left.replace('px', ''), 10),
                  parseInt(props.padding.right.replace('px', ''), 10),
                ),
                letterSpacing: props.letterSpacing
                  ? parseInt(props.letterSpacing.replace('px', ''), 10)
                  : 0,
              },
            };
          }
          if (type === 'text') {
            return {
              id: uuidv4(),
              type,
              x,
              y,
              props: {
                ...props,
                fontWeight,
                fontStyle,
                textDecoration,
                color: props?.textColor,
                listStyleType:
                  props?.listStyleType ??
                  (props?.isBullet ? 'disc' : props?.isNumbered ? 'decimal' : 'none'),
                fontSize: parseInt(props?.fontSize?.replace('px', ''), 10),
                paddingTop: parseInt(props?.padding?.top?.replace('px', ''), 10),
                paddingBottom: parseInt(props?.padding?.bottom.replace('px', ''), 10),
                paddingLeft: parseInt(props?.padding?.left?.replace('px', ''), 10),
                paddingRight: parseInt(props?.padding?.right?.replace('px', ''), 10),
                letterSpacing: parseInt(props?.letterSpacing?.replace('px', ''), 10),
                width: parseInt(props?.width, 10),
                height: parseInt(props?.height, 10),
              },
            };
          }

          if (type === 'video') {
            const v = props;
            const playback = v?.playbackSetting === 'PlayOnce' ? 'playOnce' : 'loop';
            const api2ui = (lt) => (lt === 'AlwaysLoop' ? 'always' : 'count');
            const loopType = api2ui(v?.loopType);
            const sequenceMode = v?.sequenceType === 'OneTimeSequence' ? 'oneTime' : 'loopAgain';

            const videoList = Array.isArray(v?.videos)
              ? v?.videos?.map((b) => ({
                  id: uuidv4(),
                  src: b?.videoUrl,
                  loopCount: b?.loopCount,
                  loopType: api2ui(b?.loopType ?? v?.loopType),
                }))
              : [];

            const src = videoList?.length > 0 ? videoList[0]?.src : v?.videoUrl || '';

            return {
              id: uuidv4(),
              type,
              x,
              y,
              props: {
                playback,
                loopType,
                loopCount: v?.loopCount ?? 1,
                sequenceMode,
                videoList,
                src,
                width: parseInt(v?.width ?? 200, 10),
                height: parseInt(v?.height ?? 150, 10),
                thumbnail: v?.imageUrl ?? '',
                currentIndex: 0,
                isPlaying: false,
              },
            };
          }
          return {
            id: uuidv4(),
            type,
            x,
            y,
            props:
              type !== 'image'
                ? { ...props }
                : {
                    mode: props.fitType,
                    padding: 8,
                    align: props.alignment,
                    bgColor: props.bgColor,
                    src: props.imageUrl,
                    s3_ImageUrl:
                      type === 'image'
                        ? props.s3_ImageUrl ||
                          (props.imageUrl?.startsWith(ASSET_URL)
                            ? props.imageUrl.slice(ASSET_URL.length)
                            : '')
                        : '',
                    height: parseInt(props.height, 10),
                    width: parseInt(props.width, 10),
                    imageHeight: props.imageHeight ? parseInt(props.imageHeight, 10) : undefined,
                    imageWidth: props.imageWidth ? parseInt(props.imageWidth, 10) : undefined,
                  },
          };
        }),
      );
    }
  }, [formData.template.value]);

  const compressBackgroundImage = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;
        img.onload = () => {
          const MAX_WIDTH = 1280;
          const MAX_HEIGHT = 720;
          let width = img.width;
          let height = img.height;
          if (width > MAX_WIDTH) {
            height = Math.round(height * (MAX_WIDTH / width));
            width = MAX_WIDTH;
          }
          if (height > MAX_HEIGHT) {
            width = Math.round(width * (MAX_HEIGHT / height));
            height = MAX_HEIGHT;
          }
          const canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d');
          ctx.imageSmoothingQuality = 'low';
          ctx.drawImage(img, 0, 0, width, height);
          canvas.toBlob(
            (blob) => {
              const compressedFile = new File([blob], file.name, {
                type: 'image/jpeg',
                lastModified: Date.now(),
              });
              resolve(compressedFile);
            },
            'image/jpeg',
            0.5,
          );
        };
        img.onerror = (error) => {
          reject(error);
        };
      };
      reader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const uploadImage = async (file, imageType = 'welcomeMessage') => {
    try {
      if (!file) {
        throw new Error('No file provided');
      }
      const fileSize = file.size;
      if (fileSize < 2 * 1024 * 1024) {
        const base64Data = await convertFileToBase64(file);

        const payload = {
          contentLength: file.size,
          contentType: file.type,
          filename: file.name || 'master',
          type: 'properties',
          propertyType: 'welcome_message',
          contents: base64Data,
          groupId: selectedGroup,
        };

        const response = await getPreSignedUrl(payload);
        const key = response?.data?.getPreSignUrlCMS?.key;
        if (!key) {
          console.error('Invalid upload response:', response);
          throw new Error('Invalid response from upload');
        }

        return {
          path: key,
        };
      } else {
        const totalChunks = calculateTotalChunks(fileSize);
        let uploadId = null;
        const fileChecksum = await calculateFileChecksum(file);
        const startUploadResponse = await fetch(
          `${PROPERTY_SERVICE_URL}/startMultipartUpload`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              groupId: selectedGroup,
              type: 'properties',
              propertyType: 'welcome_message',
              contentType: file.type,
              filename: file.name || 'master',
              IsCMSRequest: true,
              fileSize,
              fileChecksum,
            }),
          },
        );

        if (!startUploadResponse.ok) {
          throw new Error(`Failed to start upload: ${startUploadResponse.status}`);
        }

        const chunkData = await startUploadResponse.json();
        uploadId = chunkData?.data?.key;
        for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
          const start = chunkIndex * CHUNK_SIZE;
          const end = Math.min(start + CHUNK_SIZE, fileSize);
          const fileChunk = file.slice(start, end);

          const base64Chunk = await convertFileToBase64(fileChunk);

          const response = await fetch(`${PROPERTY_SERVICE_URL}/uploadMultipartChunk`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              groupId: selectedGroup,
              uploadId,
              sequenceNumber: chunkIndex + 1,
              contents: base64Chunk,
            }),
          });

          if (!response.ok) {
            await abortMultipartUpload(uploadId, selectedGroup);
            throw new Error(`Failed to upload chunk ${chunkIndex + 1}: ${response.status}`);
          }
        }
        const completeResponse = await completeMultipartUpload(selectedGroup, null, uploadId);

        if (completeResponse?.status === 'ok' && completeResponse?.data?.status === true) {
          return {
            path: completeResponse?.data?.message,
          };
        } else {
          throw new Error('Failed to complete multipart upload');
        }
      }
    } catch (error) {
      console.error('Error uploading image:', error);
      throw error;
    }
  };
  const createBackgroundPreview = (file) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = 320;
          canvas.height = (img.height * 320) / img.width;

          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          const previewUrl = canvas.toDataURL('image/jpeg', 0.3);
          resolve(previewUrl);
        };
        img.src = e.target.result;
      };
      reader.readAsDataURL(file);
    });
  };
  const handleBgImageUpload = async (file) => {
    const error = validateImageType(file);
    if (error) {
      setBgFileError(error);
      return;
    }
    setBgFileError(null);

    try {
      const previewUrl = await createBackgroundPreview(file);
      setBodySettings((bs) => ({
        ...bs,
        backgroundImage: previewUrl,
      }));
      setIsUploading(true);
      dispatch(stepUpLoaderCount());
      const compressedFile = await compressBackgroundImage(file);
      const response = await uploadImage(compressedFile);
      setBodySettings((bs) => ({
        ...bs,
        backgroundImage: `${ASSET_URL}${response.path}`,
      }));
    } catch (error) {
      console.error('Failed to upload background image:', error);
      setBgFileError('Failed to upload image. Please try again with a smaller file or try later.');
    } finally {
      setIsUploading(false);
      dispatch(stepDownLoaderCount());
    }
  };
  const getProps = (item) => {
    switch (item?.type?.toUpperCase()) {
      case 'HEADING':
        return item.heading;

      case 'TEXT':
        return item.text;

      case 'IMAGE':
        return item.image;

      case 'VIDEO':
        return item.video;

      default:
        return null;
    }
  };

  const dragImageElements = {};
  Object.entries(DRAG_ICONS)?.forEach(([type, src]) => {
    const img = new Image();
    img.src = src;
    img.onload = () => {
      const canvas = document?.createElement('canvas');
      canvas.width = 68;
      canvas.height = 70;
      const ctx = canvas?.getContext('2d');
      ctx?.drawImage(img, 0, 0, canvas?.width, canvas?.height);

      const scaled = new Image();
      scaled.src = canvas?.toDataURL();
      dragImageElements[type] = scaled;
    };
  });

  const onDragStart = (e, type) => {
    e?.dataTransfer?.setData('component', type);
    const imgDrag = dragImageElements[type];
    if (imgDrag) {
      e?.dataTransfer?.setDragImage(imgDrag, 34, 35);
    }
  };

  const onCanvasDragOver = (e) => {
    e.preventDefault();
    e.currentTarget.classList.add('drag-over');
  };

  const [undoStack, setUndoStack] = useState([]);
  const [redoStack, setRedoStack] = useState([]);

  const addHistory = (updater) => {
    setCanvasItems((prev) => {
      setUndoStack((us) => [...us, prev]);
      setRedoStack([]);
      const newItems = updater(prev);
      if (typeof onTemplateChange === 'function') {
        onTemplateChange();
      }
      return newItems;
    });
  };

  const handleUndo = () => {
    if (isReadOnly) return;
    if (!undoStack.length) return;
    const previous = undoStack[undoStack.length - 1];
    setUndoStack((us) => us.slice(0, -1));
    setRedoStack((rs) => [...rs, canvasItems]);
    setCanvasItems(previous);
  };

  const handleRedo = () => {
    if (isReadOnly) return;
    if (!redoStack.length) return;
    const next = redoStack[redoStack.length - 1];
    setRedoStack((rs) => rs.slice(0, -1));
    setUndoStack((us) => [...us, canvasItems]);
    setCanvasItems(next);
  };

  useImperativeHandle(ref, () => ({
    handleUndo,
    handleRedo,
    undoStack,
    redoStack,
  }));

  const onCanvasDrop = (e) => {
    e.preventDefault();
    if (isReadOnly) return;
    e.currentTarget.classList.remove('drag-over');

    const type = e.dataTransfer.getData('component');
    const data = e.dataTransfer.getData('text/plain');
    const componentType = type || data;

    if (!componentType) return;

    const canvasRect = canvasRef.current.getBoundingClientRect();
    const canvasWidth = canvasRect?.width || 800;
    const canvasHeight = canvasRect?.height || 600;

    let dropX = e.clientX - canvasRect.left;
    let dropY = e.clientY - canvasRect.top;

    const defaultWidth = DEFAULT_PROPS[componentType]?.width || 200;
    const defaultHeight = DEFAULT_PROPS[componentType]?.height || 100;

    dropX = Math.max(0, dropX);
    dropX = Math.min(canvasWidth - defaultWidth, dropX);

    dropY = Math.max(0, dropY);
    dropY = Math.min(canvasHeight - defaultHeight, dropY);

    const id = uuidv4 ? uuidv4() : Date.now();

    const isComponent = componentType === 'heading' || componentType === 'text';
    const base = DEFAULT_PROPS[componentType];

    const newProps = {
      ...base,
      ...(isComponent && {
        color: bodySettings?.textColor,
        fontFamily: bodySettings?.fontFamily,
        fontWeight: bodySettings?.fontWeight,
      }),
      width: defaultWidth,
      height: defaultHeight,
      ...(componentType === 'heading' && {
        level: 1,
        fontSize: 48,
        headingType: 'H1',
      }),
    };

    const newItem = {
      id,
      type: componentType,
      props: newProps,
      x: dropX,
      y: dropY,
    };

    addHistory((prevItems) => [...prevItems, newItem]);
    setSelectedId(id);
  };

  const onCanvasDragLeave = (e) => {
    e.currentTarget.classList.remove('drag-over');
  };

  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        const element = entry.target;
        const id = element.closest('.canvas-item')?.id;
        if (id) {
          const newHeight = Math.max(element.scrollHeight, element.offsetHeight);
          updateItemProps({ height: newHeight });
        }
      });
    });
    document.querySelectorAll('.canvas-item [contenteditable="true"]').forEach((el) => {
      resizeObserver.observe(el);
    });
    return () => resizeObserver.disconnect();
  }, [canvasItems]);

  const handleTextInput = (e, item) => {
    const el = e.currentTarget;
    const text = el.innerText;
    const selection = window.getSelection();
    const range = selection.getRangeAt(0);
    const preCaretRange = range.cloneRange();
    preCaretRange.selectNodeContents(el);
    preCaretRange.setEnd(range.endContainer, range.endOffset);
    const caretOffset = preCaretRange.toString().length;
    const newHeight = Math.max(el.scrollHeight, item.props.height);
    updateItemProps({ text, height: newHeight }, item?.id);
    requestAnimationFrame(() => {
      const sel = window.getSelection();
      const range = document.createRange();
      let charCount = 0;
      let done = false;

      function traverseNodes(node) {
        if (done) return;

        if (node.nodeType === Node.TEXT_NODE) {
          const nextCount = charCount + node.length;
          if (!done && nextCount >= caretOffset) {
            range.setStart(node, caretOffset - charCount);
            range.setEnd(node, caretOffset - charCount);
            done = true;
          }
          charCount = nextCount;
        } else {
          for (const child of node.childNodes) {
            traverseNodes(child);
          }
        }
      }

      traverseNodes(el);
      sel.removeAllRanges();
      sel.addRange(range);
    });
    if (e.nativeEvent.data === '[') {
      const range = window.getSelection().getRangeAt(0);
      const rect = range.getBoundingClientRect();
      setVariableDropdownPosition({
        x: rect.left,
        y: rect.bottom,
      });
      setShowVariableDropdown(true);

      if (variables.length === 0) {
        getWelcomeMessageVariables().then((response) => {
          setVariables(response?.data?.listWelcomeMessageVariables || []);
        });
      }
    }
    if (e.nativeEvent.data === ']' || !text.includes('[')) {
      setShowVariableDropdown(false);
    }
  };
  const handleKeyDown = (e, item) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      document.execCommand('insertLineBreak');
    }
  };

  const handleDimensionChange = (dimension, value) => {
    if (value === '') {
      updateItemProps({ imageWidth: undefined, imageHeight: undefined });
      return;
    }

    const numeric = Math.max(0, Number(value));
    const limited = Math.min(numeric, 9999);
    const item = canvasItems.find((i) => i.id === selectedId);
    const origW = item.props.naturalWidth ?? 0;
    const origH = item.props.naturalHeight ?? 0;
    if (origW <= 0 || origH <= 0) {
      if (dimension === 'width') {
        updateItemProps({ imageWidth: limited });
      } else {
        updateItemProps({ imageHeight: limited });
      }
      return;
    }
    const isSquare = origW === origH;
    const ratio = origW / origH;
    if (dimension === 'width') {
      if (isSquare) {
        updateItemProps({ imageWidth: limited, imageHeight: limited });
      } else {
        updateItemProps({
          imageWidth: limited,
          imageHeight: Math.round(limited / ratio),
        });
      }
    } else {
      if (isSquare) {
        updateItemProps({ imageWidth: limited, imageHeight: limited });
      } else {
        updateItemProps({
          imageHeight: limited,
          imageWidth: Math.round(limited * ratio),
        });
      }
    }
  };

  const getInitialImageDimensions = (src) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        resolve({
          width: img.width,
          height: img.height,
        });
      };
      img.src = src;
    });
  };

  const onSaveClick = (e) => {
    e.preventDefault();
    var template = {
      templateBody: convertToTemplateBody(bodySettings),
      templateComponent: convertToTemplateComponent(canvasItems),
    };

    if (typeof onTemplateSave === 'function') {
      onTemplateSave(template);
    }
    if (!isViewMode && typeof onNextClick === 'function') {
      onNextClick(e);
    }
    setActiveTab('components');
  };

  const hasEmptyMedia = canvasItems?.some((item) => {
    if (item?.type === 'image') {
      return !item?.props?.src;
    }
    if (item?.type === 'video') {
      if (item?.props?.playback === 'loop') {
        return item?.props?.videoList?.some((b) => !b?.src?.trim());
      }
      return !item?.props?.src;
    }
    return false;
  });

  function convertToTemplateBody(config) {
    return {
      background: config.backgroundImage || '',
      bgVideoUrl: (config.backgroundVideo && isAllowedVideoUrl(config.backgroundVideo)) ? config.backgroundVideo : '',
      bgColor: config.backgroundColor || '#ffffff',
      textColor: config.textColor || '#000000',
      fontFamily: config.fontFamily || 'Roboto',
      fontWeight: config.fontWeight || 'Regular',
    };
  }

  function convertToTemplateComponent(data) {
    return data
      .map((item) => {
        const props = item.props;
        let textForSave = props.text || '';
        if (props.listStyleType === 'decimal') {
          const lines = textForSave.split('\n');
          const firstLine = lines[0].replace(/^1\.\s*/, '');
          const restLines = lines.slice(1);
          textForSave = [firstLine, ...restLines].join('\n');
        }

        const baseProps = {
          text: textForSave,
          fontFamily: props.fontFamily,
          textAlign: props.textAlign,
          textColor: props.color,
          letterSpacing: `${props.letterSpacing}px`,
          bold: props?.fontWeight === 'Bold',
          italic: props?.fontStyle === 'italic',
          underline: props.textDecoration?.includes('underline'),
          strikethrough: props.textDecoration?.includes('line-through'),
          listStyleType: props.listStyleType,
          fontSize: `${props.fontSize}px`,
          width: props.width,
          height: props.height,
          isBullet: props.listStyleType === 'disc',
          isNumbered: props.listStyleType === 'decimal',
        };

        const coordinates = {
          xCoord: Math.round(item.x).toString(),
          yCoord: Math.round(item.y).toString(),
        };

        if (item.type === 'heading') {
          return {
            type: 'HEADING',
            heading: {
              ...baseProps,
              fontFamily: props.fontFamily,
              headingTag: `H${props.level}`,
              padding: {
                top: (props?.paddingTop ?? 0) + 'px',
                bottom: (props.paddingBottom ?? 0) + 'px',
                left: (props.paddingLeft ?? 0) + 'px',
                right: (props.paddingRight ?? 0) + 'px',
              },
              paddingAllSides: props.paddingAllSides,
              letterSpacing: `${props.letterSpacing || 0}px`,
            },
            ...coordinates,
          };
        }

        if (item.type === 'text') {
          return {
            type: 'TEXT',
            text: {
              ...baseProps,
              fontFamily: props.fontFamily,
              lineSpacing: '1.5',
            },
            ...coordinates,
          };
        }
        if (item.type === 'image') {
          return {
            type: 'IMAGE',
            image: {
              imageUrl: props.s3_ImageUrl ? `${ASSET_URL}${props.s3_ImageUrl}` : props.src,
              s3_ImageUrl: props.s3_ImageUrl,
              width: props.width + '',
              height: props.height + '',
              ...(props.mode === 'fixed' && {
                imageWidth: String(props.imageWidth ?? props.width),
                imageHeight: String(props.imageHeight ?? props.height),
              }),
              containerHeight: (props.height || props.containerHeight) + 'px',
              alignment: props.align,
              bgColor: props.bgColor,
              fitType: props.mode,
            },
            ...coordinates,
          };
        }

        if (item.type === 'video') {
          const {
            playback,
            loopType,
            loopCount,
            videoList = [],
            sequenceMode,
            thumbnail,
            src,
            width,
            height,
          } = props;

          const playbackSetting = playback === 'loop' ? 'LoopVideo' : 'PlayOnce';
          const mappedLoopType = loopType === 'always' ? 'AlwaysLoop' : 'LoopCount';
          const sequenceType = sequenceMode === 'oneTime' ? 'OneTimeSequence' : 'LoopAgain';
          const ui2api = (lt) => (lt === 'always' ? 'AlwaysLoop' : 'LoopCount');
          const safeSrc = src && isAllowedVideoUrl(src) ? src : '';
          const safeVideoList = (videoList?.length ? videoList : [{ src, loopCount, loopType }])
            ?.filter((b) => !b?.src || isAllowedVideoUrl(b?.src))
            ?.map((b) => ({
              videoUrl: b?.src,
              loopCount: b?.loopCount ?? loopCount,
              loopType: ui2api(b?.loopType ?? loopType),
              sequenceType,
            }));
          const videoPayload = {
            playbackSetting,
            imageUrl: thumbnail || '',
            ...(playbackSetting === 'LoopVideo' && mappedLoopType === 'LoopCount'
              ? {
                  loopType: mappedLoopType,
                  sequenceType,
                  videos: safeVideoList,
                }
              : playbackSetting === 'LoopVideo'
              ? {
                  loopType: mappedLoopType,
                  videoUrl: safeSrc,
                }
              : {
                  videoUrl: safeSrc,
                }),
          };

          return {
            type: 'VIDEO',
            video: {
              ...videoPayload,
              width: String(width),
              height: String(height),
            },
            ...coordinates,
          };
        }
        return null;
      })
      .filter(Boolean);
  }

  const handleResizeMouseDown = (e, id, direction) => {
    if (isReadOnly) return;

    e.stopPropagation();
    e.preventDefault();

    const item = canvasItems.find((i) => i.id === id);
    if (!item) return;

    const startX = e.clientX;
    const startY = e.clientY;
    const startWidth = item.props.width;
    const startHeight = item.props.height;
    const startLeft = item.x;
    const startTop = item.y;

    const canvasRect = canvasRef.current?.getBoundingClientRect();
    const canvasWidth = canvasRect?.width || 800;
    const canvasHeight = canvasRect?.height || 600;

    const onMouseMove = (ev) => {
      ev.preventDefault();
      const dx = ev.clientX - startX;
      const dy = ev.clientY - startY;

      let newWidth = startWidth;
      let newHeight = startHeight;
      let newX = startLeft;
      let newY = startTop;

      switch (direction) {
        case 'nw':
          newWidth = startWidth - dx;
          newHeight = startHeight - dy;
          newX = startLeft + dx;
          newY = startTop + dy;
          break;

        case 'ne':
          newWidth = startWidth + dx;
          newHeight = startHeight - dy;
          newY = startTop + dy;
          break;

        case 'se':
          newWidth = startWidth + dx;
          newHeight = startHeight + dy;
          break;

        case 'sw':
          newWidth = startWidth - dx;
          newHeight = startHeight + dy;
          newX = startLeft + dx;
          break;

        default:
          break;
      }

      newWidth = Math.max(20, newWidth);
      newHeight = Math.max(20, newHeight);

      const maxWidth = canvasWidth - newX;
      const maxHeight = canvasHeight - newY;

      newWidth = Math.min(newWidth, maxWidth);
      newHeight = Math.min(newHeight, maxHeight);

      newX = Math.max(0, newX);
      newY = Math.max(0, newY);

      addHistory((allItems) =>
        allItems.map((it) => {
          if (it.id !== id) return it;
          const textElement = document.querySelector(`[id="${id}"] div[contenteditable="true"]`);
          if (textElement && (it.type === 'heading' || it.type === 'text')) {
            textElement.style.cssText = `
            width: 100%;
            height: 100%;
            overflow: hidden;
            word-break: keep-all;
            overflow-wrap: normal;
            white-space: pre-wrap;
            box-sizing: border-box;
            text-overflow: ellipsis;
            line-height: 1.2;
            padding: 4px;
          `;
          }
          return {
            ...it,
            x: newX,
            y: newY,
            props: {
              ...it.props,
              width: newWidth,
              height: newHeight,
            },
          };
        }),
      );
    };

    const onMouseUp = () => {
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
    };

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
  };

  const hasInvalidText = canvasItems.some(
    (item) =>
      (item.type === 'heading' || item.type === 'text') &&
      (item.props.isPlaceholder || !item.props.text?.trim()),
  );

  const setItemSize = (id, newW, newH) => {
    addHistory((allItems) =>
      allItems.map((it) =>
        it.id === id
          ? {
              ...it,
              x: it.x,
              y: it.y,
              props: {
                ...it.props,
                width: newW,
                height: newH,
                containerHeight: newH,
              },
            }
          : it,
      ),
    );
  };

  const VariableDropdown = ({ position, variables, onSelect }) => {
    if (!variables.length) return null;

    return (
      <div
        className='variable-dropdown'
        style={{
          top: position?.y,
          left: position.x,
        }}
      >
        <div className='variable-header'>Variables</div>
        {variables.map((variable, index) => (
          <div key={index} className='variable-item' onClick={() => onSelect(variable)}>
            {variable.keyword}
          </div>
        ))}
      </div>
    );
  };

  const constrainToCanvas = (item, newX, newY, canvasWidth, canvasHeight) => {
    const itemWidth = item.props.width || 100;
    const itemHeight = item.props.height || 50;

    const minX = 0;
    const minY = 0;

    const maxX = Math.max(0, canvasWidth - itemWidth);
    const maxY = Math.max(0, canvasHeight - itemHeight);

    return {
      x: Math.max(minX, Math.min(maxX, newX)),
      y: Math.max(minY, Math.min(maxY, newY)),
    };
  };
  function getToolbarPosition(item) {
    const canvas = canvasRef.current;
    if (!canvas) return 'horizontal right';
    const { width: cw, height: ch } = canvas.getBoundingClientRect();
    const btnW = 60;
    const btnH = 30;
    const overflowTop = item.y < btnH;
    const overflowBottom = item.y + item.props.height + btnH > ch;
    const vertical = overflowTop || overflowBottom;
    const overflowRight = item.x + item.props.width + btnW > cw;
    const side = overflowRight ? 'left' : 'right';
    return `${vertical ? 'vertical' : 'horizontal'} ${side}`;
  }
  function getInlineToolbarPosition(item) {
    const canvas = canvasRef.current;
    if (!canvas || !inlineToolbarRef.current) return 'bottom left';
    const { width: cw, height: ch } = canvas.getBoundingClientRect();
    const { width: bw, height: bh } = inlineToolbarRef.current.getBoundingClientRect();
    const overflowBottom = item.y + item.props.height + bh > ch;
    const overflowTop = item.y - bh < 0;
    const vertical = overflowBottom && !overflowTop ? 'top' : 'bottom';
    const overflowRight = item.x + bw > cw;
    const side = overflowRight ? 'right' : 'left';
    return `${vertical} ${side}`;
  }

  const handleMouseDown = (e, id) => {
    if (isReadOnly) return;

    e.stopPropagation();
    e.preventDefault();

    const item = canvasItems.find((i) => i.id === id);
    if (!item) return;

    const canvasRect = canvasRef.current.getBoundingClientRect();
    const canvasWidth = canvasRect.width;
    const canvasHeight = canvasRect.height;

    const startX = e.clientX;
    const startY = e.clientY;
    const startItemX = item.x;
    const startItemY = item.y;

    const onMouseMove = (ev) => {
      const deltaX = ev.clientX - startX;
      const deltaY = ev.clientY - startY;

      let nx = startItemX + deltaX;
      let ny = startItemY + deltaY;

      const element = document.getElementById(item.id);
      const elementWidth = element?.offsetWidth || item.props.width || 0;
      const elementHeight = element?.offsetHeight || item.props.height || 0;

      const maxX = Math.max(0, canvasWidth - elementWidth);
      const maxY = Math.max(0, canvasHeight - elementHeight);

      nx = Math.min(maxX, Math.max(0, nx));
      ny = Math.min(maxY, Math.max(0, ny));

      addHistory((ci) => ci.map((i) => (i.id === id ? { ...i, x: nx, y: ny } : i)));
    };

    const onMouseUp = () => {
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
    };

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
  };

  const focusSelected = () => {
    const el = document?.querySelector('.canvas-item.selected [contenteditable="true"]');
    if (!el) return;
    el?.focus();
    const range = document?.createRange();
    range?.selectNodeContents(el);
    range?.collapse(false);
    const sel = window?.getSelection();
    sel?.removeAllRanges();
    sel?.addRange(range);
  };

  const handleSelect = (e, id) => {
    e.stopPropagation();
    if (id === selectedId) {
      focusSelected();
    } else {
      setSelectedId(id);
      setFileError(null);
    }
  };

  const handleCanvasClick = () => {
    setSelectedId(null);
    setFileError(null);
  };

  const removeItem = (id) => {
    addHistory((ci) => ci.filter((i) => i.id !== id));
    setSelectedId(null);
    setActiveTab('components');
  };
  const ensureWithinBounds = (value, max) => {
    return Math.min(Math.max(0, value), max);
  };

  const updateItemProps = (newProps, targetId = selectedId) => {
    addHistory((ci) =>
      ci.map((i) => (i.id === targetId ? { ...i, props: { ...i.props, ...newProps } } : i)),
    );
  };

  const toggleStyle = (styleKey) => {
    const item = canvasItems.find((i) => i.id === selectedId);
    const current = item.props[styleKey] || '';
    let next = current;
    if (styleKey === 'fontWeight') next = current === 'Bold' ? 'Regular' : 'Bold';
    if (styleKey === 'fontStyle') next = current === 'italic' ? 'normal' : 'italic';
    if (styleKey === 'textDecoration') {
      next = current?.includes('underline')
        ? current?.replace('underline', '')?.trim()
        : (current + ' underline')?.trim();
    }
    if (styleKey === 'textStrike') {
      const td = item.props.textDecoration || '';
      next = td?.includes('line-through')
        ? td?.replace('line-through', '')?.trim()
        : (td + ' line-through')?.trim();
      return updateItemProps({ textDecoration: next });
    }
    updateItemProps({ [styleKey]: next });
  };
  const applyAlign = (align) => updateItemProps({ textAlign: align });
  const applyList = (type) => {
    const key = 'listStyleType';
    const item = canvasItems.find((i) => i.id === selectedId);
    const current = item.props[key] || 'none';
    updateItemProps({ [key]: current === type ? 'none' : type });
  };

  const onBodyChange = (e) => {
    const { name, value } = e.target;
    setBodySettings((bs) => ({ ...bs, [name]: value }));
    addHistory((prevItems) =>
      prevItems.map((item) => {
        if (item.type === 'heading' || item.type === 'text') {
          return {
            ...item,
            props: {
              ...item.props,
              color: name === 'textColor' ? value : item.props.color,
              fontFamily: name === 'fontFamily' ? value : item.props.fontFamily,
              fontWeight: name === 'fontWeight' ? value : item.props.fontWeight,
            },
          };
        }
        return item;
      }),
    );
  };

  useEffect(() => {
    if (bodySettings.backgroundVideo && isAllowedVideoUrl(bodySettings.backgroundVideo)) {
      const video = document.querySelector('.bg-video');
      if (video) {
        video.autoplay = true;
        video.loop = true;
        video.muted = true;
        const ytId = getYouTubeVideoId(bodySettings.backgroundVideo);
        const vMatch = bodySettings.backgroundVideo.match(/vimeo\.com\/(?:video\/)?(\d+)/);
        if (ytId || vMatch) {
          console.log('YouTube or Vimeo URL detected, skipping direct load.');
        } else {
          video.load();
        }
      }
    }
  }, [bodySettings.backgroundVideo]);

  const toggleToolbar = (e) => {
    e.preventDefault();
    setToolbarCollapsed((c) => !c);
  };
  const validateImageType = (file) => {
    const validTypes = ['image/jpeg', 'image/jpg', 'image/png'];
    if (!validTypes.includes(file.type)) {
      return 'Please upload a valid image file (JPG/PNG)';
    }
    if (file.size > 10 * 1024 * 1024) {
      return 'Image size must be 10 MB or less';
    }
    return null;
  };
  const onBgImageDrop = async (e) => {
    e.preventDefault();
    const file =
      e.dataTransfer.files[0] || (e.dataTransfer.items && e.dataTransfer.items[0].getAsFile());
    if (!file) return;
    const error = validateImageType(file);
    if (error) {
      setBgFileError(error);
      return;
    }
    await handleBgImageUpload(file);
  };
  const onBgImageBrowse = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const error = validateImageType(file);
    if (error) {
      setBgFileError(error);
      return;
    }
    await handleBgImageUpload(file);
    e.target.value = '';
  };

  const removeBgImage = () => {
    setBodySettings((bs) => ({ ...bs, backgroundImage: null }));
    setBgFileError(null);
    const fileInput = document.getElementById('bgFile');
    if (fileInput) {
      fileInput.value = '';
    }
  };

  const onImageDrop = async (e) => {
    e.preventDefault();
    const file =
      e.dataTransfer.files[0] || (e.dataTransfer.items && e.dataTransfer.items[0].getAsFile());
    if (!file) return;
    const error = validateImageType(file);
    if (error) {
      setFileError(error);
      return;
    }
    setFileError(null);
    setIsUploading(true);
    dispatch(stepUpLoaderCount());
    try {
      const response = await uploadImage(file);
      const item = canvasItems.find((i) => i.id === selectedId);
      updateItemProps({
        src: `${ASSET_URL}${response.path}`,
        s3_ImageUrl: response.path,
        width: item?.props?.width || 150,
        height: item?.props?.height || 100,
      });
    } catch (error) {
      console.error('Failed to upload image:', error);
    } finally {
      setIsUploading(false);
      dispatch(stepDownLoaderCount());
    }
  };
  const onImageBrowse = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const error = validateImageType(file);
    if (error) {
      setFileError(error);
      return;
    }
    setFileError(null);
    setIsUploading(true);
    dispatch(stepUpLoaderCount());
    try {
      const response = await uploadImage(file);
      const imageUrl = `${ASSET_URL}${response.path}`;
      const dimensions = await getInitialImageDimensions(imageUrl);

      const item = canvasItems.find((i) => i.id === selectedId);
      updateItemProps({
        src: imageUrl,
        s3_ImageUrl: response.path,
        width: item?.props?.width || dimensions.width,
        height: item?.props?.height || dimensions.height,
        imageWidth: dimensions.width,
        imageHeight: dimensions.height,
        naturalWidth: dimensions.width,
        naturalHeight: dimensions.height,
      });
      e.target.value = '';
    } catch (error) {
      console.error('Failed to upload image:', error);
      setFileError('Failed to upload image. Please try again with a smaller file or try later.');
    } finally {
      setIsUploading(false);
      dispatch(stepDownLoaderCount());
    }
  };

  const renderComponentsPanel = () => (
    <div className='components-panel'>
      {PALETTE.map((c) => (
        <div
          key={c.type}
          className={`component-item ${isReadOnly ? 'disabled' : ''}`}
          draggable={!isReadOnly}
          onDragStart={!isReadOnly ? (e) => onDragStart(e, c.type) : undefined}
        >
          <img src={c.icon} alt={c.label} />
          <span>{c.label}</span>
        </div>
      ))}
    </div>
  );

  const renderBodyPanel = () => (
    <div className='body-panel'>
      <label className='bg-image-label'>
        Background Image
        {bodySettings.backgroundImage && (
          <>
            <button
              className='remove-link'
              onClick={(e) => {
                e.preventDefault();
                removeBgImage();
              }}
            >
              Remove
            </button>
          </>
        )}
      </label>
      <div
        className='bg-drop-zone'
        onDrop={bodySettings?.backgroundVideo ? undefined : onBgImageDrop}
        onDragOver={bodySettings.backgroundVideo ? undefined : (e) => e.preventDefault()}
        style={{
          cursor: bodySettings.backgroundVideo ? 'not-allowed' : 'pointer',
          opacity: bodySettings.backgroundVideo ? 0.5 : 1,
          pointerEvents: bodySettings.backgroundVideo ? 'none' : 'auto',
        }}
      >
        {bodySettings.backgroundImage ? (
          <img src={bodySettings.backgroundImage} alt='bg' className='bg-preview' />
        ) : (
          <div className='drop-text'>
            <AttachmentIcon style={{ color: '#888', marginRight: '14px' }} /> Drag & drop or{' '}
            <span
              className='browse-link'
              onClick={() => {
                if (!bodySettings.backgroundVideo) {
                  document.getElementById('bgFile').click();
                }
              }}
              style={{
                opacity: bodySettings.backgroundVideo ? 0.5 : 1,
                pointerEvents: bodySettings.backgroundVideo ? 'none' : 'auto',
                cursor: bodySettings.backgroundVideo ? 'not-allowed' : 'pointer',
              }}
            >
              Browse
            </span>
          </div>
        )}
        <input
          type='file'
          id='bgFile'
          accept='image/png,image/jpeg,image/jpg'
          onChange={onBgImageBrowse}
          style={{ display: 'none' }}
          disabled={!!bodySettings.backgroundVideo}
        />
      </div>
      {bodySettings.backgroundImage && (
        <>
          <button
            className='remove-link'
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('bgFile').click();
            }}
          >
            Replace
          </button>
        </>
      )}
      {bgFileError && <div style={{ color: 'red', marginTop: '4px' }}>{bgFileError}</div>}
      {maxFileSize()}
      <div className='background-video-container'>
        <CustomTextField
          item={{
            fieldName: 'Background Video URL',
            value: bodySettings.backgroundVideo,
            validations: [],
            errors: bodySettings._videoUrlError ? { required: bodySettings._videoUrlError } : {},
          }}
          type='text'
          handleInputChange={(e) => {
            const value = e.value;
            if (value && !isAllowedVideoUrl(value)) {
              setBodySettings((bs) => ({ ...bs, backgroundVideo: value, _videoUrlError: VIDEO_URL_ERROR_MSG }));
              return;
            }
            setBodySettings((bs) => ({ ...bs, _videoUrlError: null }));
            onBodyChange({ target: { name: 'backgroundVideo', value } });
          }}
          placeholder='Background video URL'
          hideAdornmentByDefault={true}
          disabled={!!bodySettings.backgroundImage}
        />
      </div>
      <div className='text-color-body-section mt-4'>
        <span className='bg-label'>Background Color</span>
        <CustomColorPicker
          name='backgroundColor'
          value={bodySettings?.backgroundColor}
          onChange={onBodyChange}
        />
      </div>
      <div className='text-color-body-section mt-4'>
        <span className='bg-label'>Text Color</span>
        <CustomColorPicker
          name='textColor'
          value={bodySettings?.textColor}
          onChange={onBodyChange}
        />
      </div>
      <hr className='horizontal-line' />
      <div className='font-family-container'>
        <CustomSelect
          item={{
            fieldName: 'Font Family',
            value: bodySettings?.fontFamily || '',
            validations: [],
            errors: {},
          }}
          valueField='value'
          labelField='label'
          handleInputChange={(e) => {
            onBodyChange({ target: { name: 'fontFamily', value: e.value } });
          }}
          options={FONT_FAMILIES?.map((font) => ({
            value: font,
            label: font,
          }))}
          hideNullOption={true}
        />
      </div>

      <div className='font-family-container'>
        <CustomSelect
          item={{
            fieldName: 'Font Weight',
            value: bodySettings?.fontWeight || '',
            validations: [],
            errors: {},
          }}
          valueField='value'
          labelField='label'
          handleInputChange={(e) => {
            onBodyChange({ target: { name: 'fontWeight', value: e.value } });
          }}
          options={FONT_WEIGHTS.map((weight) => ({
            value: weight,
            label: weight,
          }))}
          hideNullOption={true}
        />
      </div>
      <hr className='horizontal-line' />
      <div className='variable-keywords-section'>
        <div className='variable-title'>Variable Keywords</div>
        <div className='variable-description'>
          Add Variables by using keywords from the list within '[ ]', Example: [name]
        </div>
      </div>
      <div className='view-variable-list-mt-2 save'>
        <Button
          variant='outlined'
          color='secondary'
          size='small'
          onClick={() => setShowVariableList(true)}
        >
          View List
        </Button>
      </div>
      <VariableKeywordsModal isOpen={showVariableList} onClose={() => setShowVariableList(false)} />
    </div>
  );

  const handleVideoThumbnailUpload = async (file) => {
    try {
      setIsUploading(true);
      dispatch(stepUpLoaderCount());
      const response = await uploadImage(file);
      updateItemProps({ thumbnail: `${ASSET_URL}${response.path}` });
    } catch (error) {
      console.error('Failed to upload video thumbnail:', error);
      setFileError(
        'Failed to upload thumbnail. Please try again with a smaller file or try later.',
      );
    } finally {
      setIsUploading(false);
      dispatch(stepDownLoaderCount());
    }
  };

  const maxFileSize = () => {
    return (
      <div className='file-size-info mt-3'>
        <small>File type: .JPG,&nbsp;.PNG</small>
        <small> Max File Size: 10MB</small>
      </div>
    );
  };

  const handleAddVideoBlock = () => {
    setShowMultipleVideosWarning(false);
    const item = canvasItems?.find((i) => i?.id === selectedId);
    if (!item) return;

    const {
      src: currentSrc = '',
      loopType: currentLoopType = 'count',
      loopCount: currentLoopCount = 1,
      videoList: existing = [],
    } = item?.props;

    const trimmed = currentSrc?.trim();
    const blocks =
      trimmed && !existing?.some((b) => b?.src === trimmed)
        ? [
            ...existing,
            { id: uuidv4(), src: trimmed, loopType: currentLoopType, loopCount: currentLoopCount },
          ]
        : [...existing];

    blocks.push({ id: uuidv4(), src: '', loopType: 'count', loopCount: 1 });

    updateItemProps({
      videoList: blocks,
      src: blocks[0]?.src || '',
      loopType: 'count',
      loopCount: 1,
    });
  };

  const handleRemoveVideoBlock = (blockId) => {
    if (blockId == null) {
      updateItemProps({
        src: '',
        loopType: 'always',
        loopCount: 1,
        thumbnail: '',
      });
      return;
    }
    const item = canvasItems?.find((i) => i?.id === selectedId);
    const updatedList = (item?.props?.videoList || [])?.filter((b) => b?.id !== blockId);

    let nextIndex = Math.min(item?.props?.currentIndex || 0, updatedList?.length - 1);
    if (nextIndex < 0) nextIndex = 0;

    updateItemProps({
      videoList: updatedList,
      src: updatedList?.length > 0 ? updatedList[nextIndex]?.src : '',
      currentIndex: nextIndex,
      ...(updatedList.length === 0 && {
        loopCount: 1,
        loopType: 'always',
        thumbnail: '',
      }),
    });
  };

  const handleVideoBlockChange = (index, field, value) => {
    const item = canvasItems?.find((i) => i?.id === selectedId);
    if (field === 'src' && value && value.trim()) {
      if (!isAllowedVideoUrl(value)) {
        const updated = item?.props?.videoList?.map((b, i) =>
          i === index ? { ...b, [field]: value, _urlError: VIDEO_URL_ERROR_MSG } : b,
        );
        updateItemProps({ videoList: updated });
        return;
      }
    }
    const updated = item?.props?.videoList?.map((b, i) =>
      i === index ? { ...b, [field]: value, ...(field === 'src' ? { _urlError: null } : {}) } : b,
    );
    updateItemProps({ videoList: updated });
  };

  const handleVideoListDragEnd = (result) => {
    if (!result.destination) return;
    const item = canvasItems.find((i) => i?.id === selectedId);
    const newList = Array.from(item?.props?.videoList);
    const [moved] = newList?.splice(result?.source?.index, 1);
    newList?.splice(result?.destination?.index, 0, moved);
    updateItemProps({ videoList: newList });
  };

  const onLoopTypeChange = (idx) => (e) => {
    const newType = e?.target?.value;
    const item = canvasItems?.find((i) => i?.id === selectedId);

    if (newType === 'always' && item?.props?.videoList?.length > 1) {
      setShowMultipleVideosWarning(true);
      return;
    }
    handleVideoBlockChange(idx, 'loopType', newType);
  };

  const hasAnyDuplicateVideo = canvasItems?.some(
    (i) =>
      i.type === 'video' &&
      Object.values(
        i?.props?.videoList?.reduce((a, b) => {
          a[b.src] = (a[b?.src] || 0) + 1;
          return a;
        }, {}),
      ).some((c) => c > 1),
  );

  const hasEmptyVideoBlock = canvasItems?.some((item) => {
    if (item?.type !== 'video' || item?.props?.playback !== 'loop') return false;
    const { videoList: list = [], src = '' } = item?.props;
    if (list?.length === 0) {
      return !src?.trim();
    }
    return list?.some((block) => !block?.src?.trim());
  });

  const hasEmptyVideoUrl = canvasItems?.some(
    (item) =>
      item?.type === 'video' && item?.props?.playback !== 'loop' && !item?.props?.src?.trim(),
  );

  const renderEditorPanel = () => {
    if (!selectedId) return null;
    const item = canvasItems.find((i) => i?.id === selectedId);
    if (!item) return null;

    const videoList = Array.isArray(item?.props?.videoList) ? item?.props?.videoList : [];
    const urls = videoList.map((b) => b.src.trim()).filter((u) => u !== '');
    const urlCounts = urls?.reduce((acc, u) => {
      acc[u] = (acc[u] || 0) + 1;
      return acc;
    }, {});

    const firstIndexOf = urls.reduce((acc, u, idx) => {
      const src = u?.src?.trim();
      if (src && acc[src] === undefined) acc[src] = idx;
      return acc;
    }, {});

    const isSingleAlwaysLoop =
      item?.props?.videoList?.length === 1 && item?.props?.videoList[0]?.loopType === 'always';

    const isSingleLoopCount =
      item?.props?.videoList?.length === 1 && item?.props?.videoList[0]?.loopType === 'count';

    switch (item.type) {
      case 'heading':
        return (
          <div className='editor-panel'>
            {/* {header} */}
            <div className='heading-type-selector'>
              <span className='heading-label'>Heading Type</span>
              <div className='heading-options'>
                {[1, 2, 3, 4].map((level) => (
                  <div
                    key={level}
                    className={`heading-option ${item.props.level === level ? 'active' : ''}`}
                    onClick={() =>
                      updateItemProps({
                        level,
                        headingType: 'H' + level,
                        fontSize: HEADING_TO_FONT_SIZE[level],
                      })
                    }
                  >
                    H{level}
                  </div>
                ))}
              </div>
            </div>
            <hr className='horizontal-line' />
            <div className='text-color-section'>
              <span className='text-color-label'>Text Color</span>
              <CustomColorPicker
                name='color'
                value={item?.props?.color}
                onChange={(e) => updateItemProps({ color: e?.target?.value })}
              />
            </div>
            <div className='text-align-section'>
              <span className='text-align-label'>Text Align</span>
              <div className='align-options'>
                <FormatAlignLeftIcon
                  className={`align-icon ${item.props.textAlign === 'left' ? 'active' : ''}`}
                  onClick={() => updateItemProps({ textAlign: 'left' })}
                />
                <FormatAlignCenterIcon
                  className={`align-icon ${item.props.textAlign === 'center' ? 'active' : ''}`}
                  onClick={() => updateItemProps({ textAlign: 'center' })}
                />
                <FormatAlignRightIcon
                  className={`align-icon ${item.props.textAlign === 'right' ? 'active' : ''}`}
                  onClick={() => updateItemProps({ textAlign: 'right' })}
                />
                <FormatAlignJustifyIcon
                  className={`align-icon ${item.props.textAlign === 'justify' ? 'active' : ''}`}
                  onClick={() => updateItemProps({ textAlign: 'justify' })}
                />
              </div>
            </div>
            <div className='letter-spacing-section'>
              <span className='letter-spacing-label'>Letter Spacing</span>
              <div className='letter-spacing-input'>
                <CustomTextField
                  item={{
                    fieldName: 'Pixels',
                    value: item?.props?.letterSpacing || '',
                    validations: [],
                    errors: {},
                  }}
                  type='number'
                  handleInputChange={(e) => {
                    updateItemProps({ letterSpacing: Math.max(0, parseInt(e.value)) });
                  }}
                  min={1}
                  max={100}
                  step={1}
                  hideAdornmentByDefault={true}
                />
              </div>
            </div>
            <div className='padding-section'>
              <div className='toggle-row'>
                <label className='toggle-switch'>
                  <input
                    type='checkbox'
                    checked={item.props.padding > 0}
                    onChange={(e) => {
                      const isOn = e?.target?.checked;
                      if (isOn) {
                        updateItemProps({
                          padding: 8,
                          paddingAllSides: false,
                        });
                      } else {
                        updateItemProps({
                          padding: 0,
                          paddingTop: 0,
                          paddingBottom: 0,
                          paddingLeft: 0,
                          paddingRight: 0,
                          paddingAllSides: false,
                        });
                      }
                    }}
                  />
                  <span className='slider'></span>
                </label>
                <span className='padding-text'>Padding</span>
              </div>

              {item.props.padding > 0 && (
                <>
                  <div className='padding-checkbox-row'>
                    <input
                      type='checkbox'
                      checked={item?.props?.paddingAllSides}
                      onChange={(e) => {
                        const all = e?.target?.checked;
                        if (all) {
                          const allSides = item?.props?.paddingTop || '';
                          updateItemProps({
                            paddingAllSides: true,
                            paddingBottom: allSides,
                            paddingLeft: allSides,
                            paddingRight: allSides,
                          });
                        } else {
                          updateItemProps({ paddingAllSides: false });
                        }
                      }}
                    />
                    <span className='padding-all-sides-text'>Apply padding on all sides</span>
                  </div>
                  {item?.props?.paddingAllSides && (
                    <div className='all-sides-field mt-3'>
                      <CustomTextField
                        item={{
                          fieldName: 'All Sides',
                          value: item?.props?.paddingTop || '',
                          validations: [],
                          errors: {},
                        }}
                        type='number'
                        handleInputChange={(e) => {
                          const value = Math.min(50, Math.max(0, parseInt(e?.value) || 0));
                          updateItemProps({
                            paddingTop: value,
                            paddingBottom: value,
                            paddingLeft: value,
                            paddingRight: value,
                          });
                        }}
                        min={1}
                        max={50}
                        step={1}
                        hideAdornmentByDefault={true}
                      />
                    </div>
                  )}
                  {!item.props.paddingAllSides && (
                    <div className='padding-fields row d-flex mt-3'>
                      <div className='padding-horizontal'>
                        <div className='padding-container-top'>
                          <CustomTextField
                            item={{
                              fieldName: 'Top',
                              value: item?.props?.paddingTop || '',
                              validations: [],
                              errors: {},
                            }}
                            type='number'
                            handleInputChange={(e) => {
                              const value = Math.max(0, parseInt(e.value) || 0);
                              updateItemProps({
                                paddingTop: value,
                                paddingBottom: item.props.paddingBottom || 0,
                                paddingLeft: item.props.paddingLeft || 0,
                                paddingRight: item.props.paddingRight || 0,
                              });
                            }}
                            min={1}
                            max={50}
                            step={1}
                            hideAdornmentByDefault={true}
                          />
                        </div>
                        <div className='padding-container-bottom'>
                          <CustomTextField
                            item={{
                              fieldName: 'Bottom',
                              value: item?.props?.paddingBottom || '',
                              validations: [],
                              errors: {},
                            }}
                            type='number'
                            handleInputChange={(e) => {
                              const value = Math.max(0, parseInt(e.value) || 0);
                              updateItemProps({
                                paddingBottom: value,
                                paddingTop: item.props.paddingTop || 0,
                                paddingLeft: item.props.paddingLeft || 0,
                                paddingRight: item.props.paddingRight || 0,
                              });
                            }}
                            min={1}
                            max={50}
                            step={1}
                            hideAdornmentByDefault={true}
                          />
                        </div>
                      </div>
                      <div className='padding-vertical'>
                        <div className='padding-container-left'>
                          <CustomTextField
                            item={{
                              fieldName: 'Left',
                              value: item?.props?.paddingLeft || '',
                              validations: [],
                              errors: {},
                            }}
                            type='number'
                            handleInputChange={(e) => {
                              const value = Math.max(0, parseInt(e.value) || 0);
                              updateItemProps({
                                paddingLeft: value,
                                paddingTop: item.props.paddingTop || 0,
                                paddingBottom: item.props.paddingBottom || 0,
                                paddingRight: item.props.paddingRight || 0,
                              });
                            }}
                            min={1}
                            max={50}
                            step={1}
                            hideAdornmentByDefault={true}
                          />
                        </div>
                        <div className='padding-container-right'>
                          <CustomTextField
                            item={{
                              fieldName: 'Right',
                              value: item?.props?.paddingRight || '',
                              validations: [],
                              errors: {},
                            }}
                            type='number'
                            handleInputChange={(e) => {
                              const value = Math.max(0, parseInt(e.value) || 0);
                              updateItemProps({
                                paddingRight: value,
                                paddingTop: item.props.paddingTop || 0,
                                paddingBottom: item.props.paddingBottom || 0,
                                paddingLeft: item.props.paddingLeft || 0,
                              });
                            }}
                            min={1}
                            max={50}
                            step={1}
                            hideAdornmentByDefault={true}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        );
      case 'text':
        return (
          <div className='editor-panel'>
            <div className='text-color-section'>
              <span className='text-color-label'>Text Color</span>
              <CustomColorPicker
                name='textColor'
                value={item.props.color}
                onChange={(e) => updateItemProps({ color: e.target.value })}
              />
            </div>
            <hr className='horizontal-line' />
            <div className='text-align-section'>
              <span className='text-align-label'>Text Align</span>
              <div className='align-options'>
                <FormatAlignLeftIcon
                  className={`align-icon ${item.props.textAlign === 'left' ? 'active' : ''}`}
                  onClick={() => updateItemProps({ textAlign: 'left' })}
                />
                <FormatAlignCenterIcon
                  className={`align-icon ${item.props.textAlign === 'center' ? 'active' : ''}`}
                  onClick={() => updateItemProps({ textAlign: 'center' })}
                />
                <FormatAlignRightIcon
                  className={`align-icon ${item.props.textAlign === 'right' ? 'active' : ''}`}
                  onClick={() => updateItemProps({ textAlign: 'right' })}
                />
                <FormatAlignJustifyIcon
                  className={`align-icon ${item.props.textAlign === 'justify' ? 'active' : ''}`}
                  onClick={() => updateItemProps({ textAlign: 'justify' })}
                />
              </div>
            </div>
            <div className='letter-spacing-section'>
              <span className='letter-spacing-label'>Letter Spacing</span>
              <div className='letter-spacing-input' style={{ position: 'relative' }}>
                <CustomTextField
                  item={{
                    fieldName: 'Pixels',
                    value: item?.props?.letterSpacing || '',
                    validations: [],
                    errors: {},
                  }}
                  type='number'
                  handleInputChange={(e) => {
                    updateItemProps({ letterSpacing: Math.max(0, parseInt(e.value)) });
                  }}
                  min={1}
                  max={100}
                  step={1}
                  hideAdornmentByDefault={true}
                />
              </div>
            </div>
          </div>
        );
      case 'image':
        return (
          <div className='body-panel'>
            {item.props.src && (
              <button
                className='remove-link'
                onClick={() => {
                  updateItemProps({
                    src: '',
                    s3_ImageUrl: '',
                    imageWidth: undefined,
                    imageHeight: undefined,
                    naturalWidth: undefined,
                    naturalHeight: undefined,
                  });
                }}
              >
                Remove
              </button>
            )}
            <div
              className='bg-drop-zone'
              onDrop={
                item.props.src && !item.props.s3_ImageUrl ? (e) => e.preventDefault() : onImageDrop
              }
              onDragOver={(e) => e.preventDefault()}
              style={{
                cursor: item.props.src && !item.props.s3_ImageUrl ? 'not-allowed' : 'pointer',
                opacity: item.props.src && !item.props.s3_ImageUrl ? 0.5 : 1,
              }}
            >
              {item.props.src ? (
                <>
                  <img src={item.props.src} alt='preview' className='img-preview fit-img' />
                </>
              ) : (
                <div className='drop-text'>
                  <AttachmentIcon style={{ color: '#888', marginRight: '14px' }} /> Drag & drop
                  image here or{' '}
                  <span
                    className='browse-link'
                    onClick={() => {
                      if (item.props.src && !item.props.s3_ImageUrl) return;
                      document.getElementById(`imageUpload-${item.id}`).click();
                    }}
                  >
                    Browse
                  </span>
                </div>
              )}
              <input
                type='file'
                id={`imageReplace-${item.id}`}
                accept='image/png,image/jpeg,image/jpg'
                onChange={async (e) => {
                  const file = e.target.files[0];
                  if (!file) return;
                  const error = validateImageType(file);
                  if (error) {
                    setFileError(error);
                    return;
                  }
                  setFileError(null);
                  setIsUploading(true);
                  dispatch(stepUpLoaderCount());
                  try {
                    const response = await uploadImage(file);
                    const url = `${ASSET_URL}${response.path}`;
                    const { width: w, height: h } = await getInitialImageDimensions(url);
                    updateItemProps({
                      src: url,
                      s3_ImageUrl: response.path,
                      imageWidth: w,
                      imageHeight: h,
                      naturalWidth: w,
                      naturalHeight: h,
                    });
                    e.target.value = '';
                  } catch (error) {
                    console.error('Failed to replace image:', error);
                  } finally {
                    setIsUploading(false);
                    dispatch(stepDownLoaderCount());
                  }
                }}
                style={{ display: 'none' }}
              />
              <input
                type='file'
                id={`imageUpload-${item.id}`}
                accept='image/png,image/jpeg,image/jpg'
                onChange={onImageBrowse}
                style={{ display: 'none' }}
              />
            </div>
            {item.props.src && (
              <button
                className='remove-link'
                onClick={(e) => {
                  e.preventDefault();
                  const replaceInput = document.getElementById(`imageReplace-${item.id}`);
                  if (replaceInput) {
                    replaceInput.click();
                  }
                }}
              >
                Replace
              </button>
            )}
            <div className='file-size-info mt-3'>
              {fileError && <div style={{ color: 'red', marginTop: '4px' }}>{fileError}</div>}
              <small>File type: .JPG,&nbsp;.PNG</small>
              <small> Max File Size: 10MB</small>
            </div>
            <div className='mode-buttons'>
              {['fit', 'fill', 'fixed'].map((m) => {
                const iconMap = {
                  fit: fitIcon,
                  fill: fillIcon,
                  fixed: fixedIcon,
                };
                return (
                  <button
                    key={m}
                    className={`mode-button ${item.props.mode === m ? 'active' : ''}`}
                    onClick={async (e) => {
                      e.preventDefault();
                      if (m === 'fit') {
                        updateItemProps({ mode: m });
                      } else if (m === 'fill') {
                        updateItemProps({
                          mode: m,
                          align: DEFAULT_PROPS?.image?.align,
                        });
                      } else if (m === 'fixed') {
                        updateItemProps({
                          mode: m,
                          align: DEFAULT_PROPS?.image?.align,
                        });
                        try {
                          const src = item?.props?.src;
                          if (src) {
                            const { width, height } = await getInitialImageDimensions(src);
                            updateItemProps({
                              imageWidth: width,
                              imageHeight: height,
                              naturalWidth: width,
                              naturalHeight: height,
                            });
                          }
                        } catch (err) {
                          console.error('Error fetching image dimensions:', err);
                        }
                      }
                    }}
                  >
                    <img
                      src={iconMap[m]}
                      alt={m}
                      style={{
                        width: 54,
                        height: 38,
                        filter:
                          item.props.mode === m
                            ? 'brightness(0) saturate(100%) invert(83%) sepia(31%) saturate(1199%) hue-rotate(95deg) brightness(99%) contrast(87%)'
                            : 'none',
                      }}
                    />
                    {m?.charAt(0)?.toUpperCase() + m?.slice(1)}
                  </button>
                );
              })}
            </div>
            {item.props.mode !== 'fixed' && (
              <div className='background-video-container'>
                <CustomTextField
                  item={{
                    fieldName: 'Add URL',
                    value: item.props.src && item.props.s3_ImageUrl ? '' : item.props.src || '',
                    validations: [],
                    errors: item?.props?._imageUrlError ? { required: item?.props?._imageUrlError } : {},
                  }}
                  type='text'
                  handleInputChange={(e) => {
                    const val = e.value;
                    if (val && !isAllowedExternalUrl(val)) {
                      updateItemProps({ src: val, s3_ImageUrl: '', _imageUrlError: INVALID_URL_ERROR_MSG });
                      setFileError(null);
                      return;
                    }
                    updateItemProps({ src: val, s3_ImageUrl: '', _imageUrlError: null });
                    setFileError(null);
                  }}
                  placeholder='AddURL'
                  hideAdornmentByDefault={true}
                  disabled={Boolean(item.props.s3_ImageUrl)}
                />
              </div>
            )}

            {item.props.mode === 'fixed' && (
              <div className='dimensions-section'>
                <div className='dimensions-row'>
                  <div className='dimension-field'>
                    <div className='dimension-input'>
                      <CustomTextField
                        item={{
                          fieldName: 'Width',
                          value: item?.props?.imageWidth || '',
                          validations: [],
                          errors: {},
                        }}
                        type='number'
                        handleInputChange={(e) => {
                          handleDimensionChange('width', e.value);
                        }}
                        min={0}
                        max={9999}
                        step={1}
                        hideAdornmentByDefault={true}
                      />
                    </div>
                  </div>
                  <img
                    src={Linked}
                    alt='Linked'
                    style={{
                      width: 30,
                      height: 17,
                      margin: '10px',
                      verticalAlign: 'middle',
                    }}
                  />
                  <div className='dimension-field'>
                    <div className='dimension-input'>
                      <CustomTextField
                        item={{
                          fieldName: 'Height',
                          value: item?.props?.imageHeight || '',
                          validations: [],
                          errors: {},
                        }}
                        type='number'
                        handleInputChange={(e) => {
                          handleDimensionChange('height', e.value);
                        }}
                        min={0}
                        max={9999}
                        step={1}
                        hideAdornmentByDefault={true}
                      />
                    </div>
                  </div>
                </div>
                <div className='background-video-container'>
                  <CustomTextField
                    item={{
                      fieldName: 'Add URL',
                      value: item.props.src && item.props.s3_ImageUrl ? '' : item.props.src || '',
                      validations: [],
                      errors: item?.props?._imageUrlError ? { required: item?.props?._imageUrlError } : {},
                    }}
                    type='text'
                    handleInputChange={(e) => {
                      const val = e.value;
                      if (val && !isAllowedExternalUrl(val)) {
                        updateItemProps({ src: val, s3_ImageUrl: '', _imageUrlError: INVALID_URL_ERROR_MSG });
                        setFileError(null);
                        return;
                      }
                      updateItemProps({ src: val, s3_ImageUrl: '', _imageUrlError: null });
                      setFileError(null);
                    }}
                    placeholder='AddURL'
                    hideAdornmentByDefault={true}
                    disabled={Boolean(item.props.s3_ImageUrl)}
                  />
                </div>
              </div>
            )}

            {item?.props?.mode === 'fit' && (
              <div className='alignment-buttons'>
                <label>Alignment</label>
                <div className='alignment-icons'>
                  <IconButton
                    onClick={() => updateItemProps({ align: 'left' })}
                    className={`align-btn ${item.props.align === 'left' ? 'active' : ''}`}
                    disableRipple
                    style={{ border: 'none' }}
                  >
                    <img
                      src={leftIcon}
                      alt='Align Left'
                      style={{
                        filter:
                          item.props.align === 'left'
                            ? 'brightness(0) saturate(100%) invert(83%) sepia(31%) saturate(1199%) hue-rotate(95deg) brightness(99%) contrast(87%)'
                            : 'none',
                      }}
                    />
                  </IconButton>
                  <IconButton
                    onClick={() => updateItemProps({ align: 'center' })}
                    className={`align-btn ${item.props.align === 'center' ? 'active' : ''}`}
                    disableRipple
                    style={{ border: 'none' }}
                  >
                    <img
                      src={centerIcon}
                      alt='Align Center'
                      style={{
                        filter:
                          item.props.align === 'center'
                            ? 'brightness(0) saturate(100%) invert(83%) sepia(31%) saturate(1199%) hue-rotate(95deg) brightness(99%) contrast(87%)'
                            : 'none',
                      }}
                    />
                  </IconButton>
                  <IconButton
                    onClick={() => updateItemProps({ align: 'right' })}
                    className={`align-btn ${item.props.align === 'right' ? 'active' : ''}`}
                    disableRipple
                    style={{ border: 'none' }}
                  >
                    <img
                      src={rightIcon}
                      alt='Align Right'
                      style={{
                        filter:
                          item.props.align === 'right'
                            ? 'brightness(0) saturate(100%) invert(83%) sepia(31%) saturate(1199%) hue-rotate(95deg) brightness(99%) contrast(87%)'
                            : 'none',
                      }}
                    />
                  </IconButton>
                </div>
              </div>
            )}
            <div className='text-color-component-section mt-4'>
              <span className='bg-label'>Background Color</span>

              <CustomColorPicker
                name='backgroundColor'
                value={item.props.bgColor}
                onChange={(e) => updateItemProps({ bgColor: e.target.value })}
              />
            </div>
          </div>
        );
      case 'video':
        return (
          <div className='editor-panel'>
            <div className='video-container-panel'>
              <div className='playback-settings'>
                <CustomSelect
                  item={{
                    fieldName: 'Playback settings',
                    value: item?.props?.playback,
                    validations: [],
                    errors: {},
                  }}
                  valueField='value'
                  labelField='label'
                  handleInputChange={(e) =>
                    updateItemProps({
                      playback: e.value,
                      ...(e.value === 'loop'
                        ? { loopType: 'always' }
                        : { loopType: 'count', loopCount: 1 }),
                    })
                  }
                  options={[
                    { value: 'playOnce', label: 'Play Once' },
                    { value: 'loop', label: 'Loop Video' },
                  ]}
                  hideNullOption={true}
                />
              </div>

              {item?.props?.playback !== 'loop' && (
                <div className='background-video-container'>
                  <CustomTextField
                    item={{
                      fieldName: 'Paste video URL',
                      value: item?.props?.src,
                      validations: [],
                      errors: item?.props?._videoUrlError ? { required: item?.props?._videoUrlError } : {},
                    }}
                    type='text'
                    handleInputChange={(e) => {
                      const val = e.value;
                      if (val && !isAllowedVideoUrl(val)) {
                        updateItemProps({ src: val, _videoUrlError: VIDEO_URL_ERROR_MSG });
                        return;
                      }
                      updateItemProps({ src: val, _videoUrlError: null });
                    }}
                    placeholder='Paste video URL'
                    hideAdornmentByDefault={true}
                  />
                </div>
              )}

              {item?.props?.playback === 'loop' && (
                <>
                  {item?.props?.videoList?.length === 0 ? (
                    <div
                      style={{
                        border: '0.5px solid #707070',
                        borderRadius: '9px',
                        marginTop: '25px',
                        padding: '8px',
                        marginBottom: '8px',
                        marginRight: '14px',
                        position: 'relative',
                      }}
                    >
                      <div className='background-video-container' style={{ margin: 0 }}>
                        <CustomTextField
                          item={{
                            fieldName: 'Paste video URL',
                            value: item?.props?.src,
                            validations: [],
                            errors: item?.props?._videoUrlError ? { required: item?.props?._videoUrlError } : {},
                          }}
                          type='text'
                          handleInputChange={(e) => {
                            const val = e?.value;
                            if (val && !isAllowedVideoUrl(val)) {
                              updateItemProps({ src: val, _videoUrlError: VIDEO_URL_ERROR_MSG });
                              return;
                            }
                            updateItemProps({ src: val, _videoUrlError: null });
                          }}
                          placeholder='Paste video URL'
                          endAdornment
                          adromentValue={
                            <InputAdornment position='end'>
                              <IconButton
                                size='small'
                                onClick={(e) => {
                                  e.stopPropagation();
                                  updateItemProps({ src: '', loopType: 'always' });
                                }}
                              >
                                <CloseIcon fontSize='small' />
                              </IconButton>
                            </InputAdornment>
                          }
                        />
                      </div>
                      <div
                        className='loop-settings d-flex align-items-center'
                        style={{ gap: '16px', marginTop: '16px' }}
                      >
                        <CustomSelect
                          item={{
                            fieldName: 'Loop Type',
                            value: item?.props?.loopType,
                            validations: [],
                            errors: {},
                          }}
                          valueField='value'
                          labelField='label'
                          handleInputChange={(e) =>
                            updateItemProps({
                              loopType: e?.value,
                              videoList: e?.value === 'always' ? [] : item?.props?.videoList,
                            })
                          }
                          options={[
                            { value: 'always', label: 'Always Loop' },
                            { value: 'count', label: 'Loop Count' },
                          ]}
                          hideNullOption
                        />
                        <CustomTextField
                          item={{
                            fieldName: 'Loop Count',
                            value: item?.props?.loopCount,
                            validations: [],
                            errors: {},
                          }}
                          type='number'
                          handleInputChange={(e) => {
                            const n = parseInt(e?.value, 10);
                            const loopCount = isNaN(n) ? 1 : Math.max(1, n);
                            updateItemProps({ loopCount });
                          }}
                          min={1}
                          className='counter-field'
                          disabled={item?.props?.loopType !== 'count'}
                        />
                      </div>

                      <div className='add-video-wrapper mt-3'>
                        {(() => {
                          const disabled = item?.props?.loopType === 'always';
                          return (
                            <Link
                              component='button'
                              variant='body2'
                              onClick={disabled ? undefined : handleAddVideoBlock}
                              className={`add-video-link${disabled ? ' disabled' : ''}`}
                            >
                              Add Video
                            </Link>
                          );
                        })()}
                      </div>
                    </div>
                  ) : (
                    /* Summary box after Add Video */
                    <DragDropContext onDragEnd={handleVideoListDragEnd}>
                      <Droppable droppableId={`video-list-${selectedId}`} direction='vertical'>
                        {(provided) => (
                          <div
                            ref={provided?.innerRef}
                            {...provided?.droppableProps}
                            style={{
                              border: '0.5px solid #707070',
                              borderRadius: '9px',
                              marginTop: '25px',
                              marginRight: '14px',
                              padding:
                                item?.props?.videoList?.length <= 1 ? '8px' : '8px 8px 8px 0px',
                              marginBottom: '8px',
                              position: 'relative',
                            }}
                          >
                            {item?.props?.videoList?.map((block, idx) => (
                              <Draggable
                                key={block?.id}
                                draggableId={block?.id}
                                index={idx}
                                isDragDisabled={item?.props?.videoList?.length <= 1}
                              >
                                {(prov) => (
                                  <div
                                    ref={prov?.innerRef}
                                    {...prov?.draggableProps}
                                    style={{ marginBottom: 16, ...prov?.draggableProps?.style }}
                                  >
                                    <div
                                      style={
                                        item?.props?.videoList?.length > 1
                                          ? { display: 'flex', alignItems: 'center' }
                                          : undefined
                                      }
                                    >
                                      {item?.props?.videoList?.length > 1 && (
                                        <IconButton aria-label='drag' {...prov.dragHandleProps}>
                                          <DragIndicatorIcon fontSize='small' color='disabled' />
                                        </IconButton>
                                      )}
                                      <div>
                                        <div
                                          className='background-video-container'
                                          style={{ margin: 0, width: '100%' }}
                                        >
                                          <CustomTextField
                                            item={{
                                              fieldName: 'Paste video URL',
                                              value: block?.src,
                                              validations:
                                                block?.src?.trim() &&
                                                urlCounts[block?.src?.trim()] > 1 &&
                                                firstIndexOf[block?.src?.trim()] !== idx
                                                  ? ['duplicate']
                                                  : [],
                                              errors: {
                                                duplicate: 'Duplicate video URL',
                                                ...(block?._urlError ? { required: block._urlError } : {}),
                                              },
                                            }}
                                            type='text'
                                            placeholder='Paste video URL'
                                            fullWidth
                                            handleInputChange={(e) =>
                                              handleVideoBlockChange(idx, 'src', e?.value)
                                            }
                                            endAdornment
                                            adromentValue={
                                              <InputAdornment position='end'>
                                                <IconButton
                                                  edge='end'
                                                  size='small'
                                                  onClick={(ev) => {
                                                    ev.stopPropagation();
                                                    handleRemoveVideoBlock(block?.id);
                                                  }}
                                                >
                                                  <CloseIcon fontSize='small' />
                                                </IconButton>
                                              </InputAdornment>
                                            }
                                          />
                                        </div>

                                        <div
                                          className='loop-settings d-flex align-items-center'
                                          style={{ gap: '16px', marginTop: '16px' }}
                                        >
                                          <CustomSelect
                                            item={{
                                              fieldName: 'Loop Type',
                                              value: block?.loopType,
                                              validations: [],
                                              errors: {},
                                            }}
                                            options={[
                                              { value: 'always', label: 'Always Loop' },
                                              { value: 'count', label: 'Loop Count' },
                                            ]}
                                            valueField='value'
                                            labelField='label'
                                            hideNullOption
                                            handleInputChange={(e) => {
                                              onLoopTypeChange(idx)({
                                                target: { value: e?.value },
                                              });
                                            }}
                                            style={{ width: 150 }}
                                          />
                                          <CustomTextField
                                            item={{
                                              fieldName: 'Loop Count',
                                              value: block?.loopCount,
                                              validations: [],
                                              errors: {},
                                            }}
                                            type='number'
                                            placeholder='Count'
                                            handleInputChange={(e) => {
                                              const n = parseInt(e?.value, 10);
                                              const loopCount = isNaN(n) ? 1 : Math.max(1, n);
                                              handleVideoBlockChange(idx, 'loopCount', loopCount);
                                            }}
                                            min={1}
                                            disabled={block?.loopType !== 'count'}
                                            className='counter-field'
                                          />
                                        </div>
                                        {/* Add Video on last */}

                                        {idx === item?.props?.videoList?.length - 1 &&
                                          (() => {
                                            const disabled = block?.loopType === 'always';

                                            return (
                                              <div style={{ marginTop: 8 }}>
                                                <Link
                                                  component='button'
                                                  variant='body2'
                                                  onClick={
                                                    disabled ? undefined : handleAddVideoBlock
                                                  }
                                                  className={`add-video-link${
                                                    disabled ? ' disabled' : ''
                                                  }`}
                                                >
                                                  Add Video
                                                </Link>
                                              </div>
                                            );
                                          })()}
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </Draggable>
                            ))}
                            <Modal
                              open={showMultipleVideosWarning}
                              onClose={() => setShowMultipleVideosWarning(false)}
                            >
                              <div
                                style={{
                                  position: 'absolute',
                                  top: '50%',
                                  left: '50%',
                                  transform: 'translate(-50%, -50%)',
                                  width: 400,
                                  height: 200,
                                  background: 'white',
                                  borderRadius: 10,
                                  padding: 24,
                                  textAlign: 'center',
                                  boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
                                }}
                              >
                                <div className='d-flex align-items-center justify-content-center mb-3 gap-2'>
                                  <WarningAmberRoundedIcon />
                                  <span style={{ fontSize: '20px', fontWeight: 'bold' }}>
                                    Multiple videos found
                                  </span>
                                </div>
                                <p className='warning-popup-description'>
                                  Only one video is allowed with Always Loop.
                                  <br />
                                  Please remove additional videos to use this option.
                                </p>
                                <Button
                                  variant='contained'
                                  size='large'
                                  color='primary'
                                  onClick={() => setShowMultipleVideosWarning(false)}
                                >
                                  Back
                                </Button>
                              </div>
                            </Modal>
                            {provided?.placeholder}
                          </div>
                        )}
                      </Droppable>
                    </DragDropContext>
                  )}
                  {item?.props?.videoList?.length > 0 &&
                    !isSingleAlwaysLoop &&
                    !isSingleLoopCount && (
                      <FormControl component='fieldset' style={{ marginTop: 8, marginBottom: 16 }}>
                        <RadioGroup
                          row
                          value={item?.props?.sequenceMode}
                          onChange={(e) =>
                            updateItemProps({
                              sequenceMode: e?.target?.value,
                            })
                          }
                        >
                          <FormControlLabel
                            value='oneTime'
                            className='sequenceModeLabel'
                            control={<Radio size='small' />}
                            label='One-time sequence'
                          />
                          <FormControlLabel
                            value='loopAgain'
                            className='sequenceModeLabel'
                            control={<Radio size='small' />}
                            label='Loop again'
                          />
                        </RadioGroup>
                      </FormControl>
                    )}
                </>
              )}

              {item?.props?.playback === 'playOnce' && (
                <>
                  <div
                    className='video-thumb-label-row'
                    style={{
                      marginTop: 35,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}
                  >
                    <div className='d-flex align-items-center'>
                      <span className='bg-image-label'>Video Thumbnail</span>
                      <Tooltip title='Display image after video playback' placement='right'>
                        <InfoIcon style={{ fontSize: '14px' }} className='ms-2' />
                      </Tooltip>
                    </div>
                    {item?.props?.thumbnail && (
                      <button
                        className='remove-link ms-2'
                        onClick={(e) => {
                          e.preventDefault();
                          updateItemProps({ thumbnail: '' });
                          const fileInput = document.getElementById(`videoThumb-${item?.id}`);
                          if (fileInput) fileInput.value = '';
                        }}
                      >
                        Remove
                      </button>
                    )}
                  </div>
                  <div
                    className='video-thumb-drop-zone'
                    onDrop={(e) => {
                      e.preventDefault();
                      const file = e?.dataTransfer?.files[0];
                      if (!file) return;
                      const error = validateImageType(file);
                      if (error) {
                        setFileError(error);
                        return;
                      }
                      setFileError(null);
                      handleVideoThumbnailUpload(file);
                    }}
                    onDragOver={(e) => e.preventDefault()}
                    style={{
                      marginTop: '15px',
                      textAlign: 'center',
                      height: '150px',
                      width: '90%',
                    }}
                  >
                    {item.props.thumbnail ? (
                      <img
                        src={item?.props?.thumbnail}
                        className='thumb-preview'
                        alt='Video thumbnail preview'
                      />
                    ) : (
                      <div>
                        <AttachmentIcon style={{ color: '#888', marginRight: '14px' }} />
                        <span style={{ color: '#888' }}>Drag & drop thumbnail or </span>
                        <span
                          className='browse-link'
                          onClick={() => document.getElementById(`videoThumb-${item?.id}`).click()}
                          style={{ color: '#29E67C', cursor: 'pointer' }}
                        >
                          Browse
                        </span>
                      </div>
                    )}
                    <input
                      type='file'
                      id={`videoThumb-${item?.id}`}
                      accept='image/png,image/jpeg,image/jpg'
                      style={{ display: 'none' }}
                      onChange={(e) => {
                        const file = e?.target?.files[0];
                        if (!file) return;
                        const error = validateImageType(file);
                        if (error) {
                          setFileError(error);
                        } else {
                          setFileError(null);
                          handleVideoThumbnailUpload(file);
                        }
                        e.target.value = '';
                      }}
                    />
                  </div>
                  {item?.props?.thumbnail && (
                    <>
                      <button
                        className='remove-link'
                        onClick={(e) => {
                          e.preventDefault();
                          document.getElementById(`videoThumb-${item.id}`).click();
                        }}
                      >
                        Replace
                      </button>
                    </>
                  )}
                  {fileError && <div style={{ color: 'red', marginTop: 4 }}>{fileError}</div>}
                  {maxFileSize()}
                </>
              )}

              {item?.props?.playback === 'loop' &&
                item?.props?.videoList?.length > 0 &&
                item?.props?.sequenceMode === 'oneTime' &&
                !isSingleAlwaysLoop &&
                !isSingleLoopCount && (
                  <>
                    <div
                      className='video-thumb-label-row'
                      style={{
                        marginTop: 35,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                      }}
                    >
                      <div className='d-flex align-items-center'>
                        <span className='bg-image-label'>Video Thumbnail</span>
                        <Tooltip title='Display image after video playback' placement='right'>
                          <InfoIcon style={{ fontSize: '14px' }} className='ms-2' />
                        </Tooltip>
                      </div>

                      {item?.props?.thumbnail && (
                        <button
                          className='remove-link ms-2'
                          style={{ marginLeft: 'auto' }}
                          onClick={(e) => {
                            e.preventDefault();
                            updateItemProps({ thumbnail: '' });
                            const fileInput = document.getElementById(`videoThumb-${item.id}`);
                            if (fileInput) fileInput.value = '';
                          }}
                        >
                          Remove
                        </button>
                      )}
                    </div>
                    <div
                      className='video-thumb-drop-zone'
                      onDrop={(e) => {
                        e.preventDefault();
                        const file = e?.dataTransfer?.files[0];
                        if (!file) return;
                        const error = validateImageType(file);
                        if (error) {
                          setFileError(error);
                          return;
                        }
                        setFileError(null);
                        handleVideoThumbnailUpload(file);
                      }}
                      onDragOver={(e) => e.preventDefault()}
                      style={{
                        marginTop: '15px',
                        textAlign: 'center',
                        height: '150px',
                        width: '90%',
                      }}
                    >
                      {item.props.thumbnail ? (
                        <img
                          src={item.props.thumbnail}
                          className='thumb-preview'
                          alt='Video thumbnail preview'
                        />
                      ) : (
                        <div>
                          <AttachmentIcon style={{ color: '#888', marginRight: '14px' }} />
                          <span style={{ color: '#888' }}>Drag & drop thumbnail or </span>
                          <span
                            className='browse-link'
                            onClick={() => document.getElementById(`videoThumb-${item.id}`).click()}
                            style={{ color: '#29E67C', cursor: 'pointer' }}
                          >
                            Browse
                          </span>
                        </div>
                      )}
                      <input
                        type='file'
                        id={`videoThumb-${item.id}`}
                        accept='image/png,image/jpeg,image/jpg'
                        style={{ display: 'none' }}
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (!file) return;
                          const error = validateImageType(file);
                          if (error) {
                            setFileError(error);
                          } else {
                            setFileError(null);
                            handleVideoThumbnailUpload(file);
                          }
                          e.target.value = '';
                        }}
                      />
                    </div>
                    {item.props.thumbnail && (
                      <>
                        <button
                          className='remove-link'
                          onClick={(e) => {
                            e.preventDefault();
                            document.getElementById(`videoThumb-${item.id}`).click();
                          }}
                        >
                          Replace
                        </button>
                      </>
                    )}
                    {fileError && <div style={{ color: 'red', marginTop: 4 }}>{fileError}</div>}
                    {maxFileSize()}
                  </>
                )}
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  useEffect(() => {
    const ytLoopCounts = {};
    const replayYT = (iframe) => {
      try {
        iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'seekTo', args: [0, true] }), '*');
        iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'playVideo', args: [] }), '*');
      } catch (err) {}
    };
    const handleYTMessage = (event) => {
      if (!event.origin?.includes('youtube')) return;
      let data;
      try {
        data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
      } catch (e) {
        return;
      }
      if (data?.info?.playerState === 0) {
        const iframes = document.querySelectorAll('iframe[data-yt-item-id]');
        let matchedIframe = null;
        let itemId = null;
        for (const iframe of iframes) {
          if (iframe.contentWindow === event.source) {
            matchedIframe = iframe;
            itemId = iframe.getAttribute('data-yt-item-id');
            break;
          }
        }
        if (!itemId || !matchedIframe) return;
        setCanvasItems((prev) => {
          const item = prev.find((i) => i?.id === itemId);
          if (!item) return prev;
          const { playback, loopType, sequenceMode, videoList = [], currentIndex = 0 } = item.props;
          if (playback === 'loop' && loopType === 'always') {
            replayYT(matchedIframe);
            return prev;
          }
          const stopPlaying = () => {
            setUndoStack((us) => [...us, prev]);
            setRedoStack([]);
            if (typeof onTemplateChange === 'function') onTemplateChange();
            return prev.map((i) =>
              i?.id === itemId ? { ...i, props: { ...i.props, isPlaying: false } } : i,
            );
          };
          if (!videoList || videoList.length === 0) {
            if (loopType === 'count') {
              const target = item.props.loopCount || 1;
              ytLoopCounts[itemId] = (ytLoopCounts[itemId] || 0) + 1;
              if (ytLoopCounts[itemId] < target) {
                replayYT(matchedIframe);
                return prev;
              }
              ytLoopCounts[itemId] = 0;
            }
            return stopPlaying();
          }
          if (loopType === 'count') {
            const target = videoList[currentIndex]?.loopCount || 1;
            ytLoopCounts[itemId] = (ytLoopCounts[itemId] || 0) + 1;
            if (ytLoopCounts[itemId] < target) {
              replayYT(matchedIframe);
              return prev;
            }
          }
          let nextIndex = loopType === 'count' ? currentIndex + 1 : currentIndex;
          if (nextIndex >= videoList.length) {
            if (sequenceMode === 'loopAgain') {
              nextIndex = 0;
            } else {
              ytLoopCounts[itemId] = 0;
              return stopPlaying();
            }
          }
          if (nextIndex === currentIndex) {
            ytLoopCounts[itemId] = 0;
            replayYT(matchedIframe);
            return prev;
          }
          ytLoopCounts[itemId] = 0;
          const nextSrc = videoList[nextIndex]?.src;
          setUndoStack((us) => [...us, prev]);
          setRedoStack([]);
          if (typeof onTemplateChange === 'function') onTemplateChange();
          return prev.map((i) =>
            i?.id === itemId
              ? { ...i, props: { ...i.props, src: nextSrc, currentIndex: nextIndex, isPlaying: true } }
              : i,
          );
        });
      }
    };
    window.addEventListener('message', handleYTMessage);
    return () => window.removeEventListener('message', handleYTMessage);
  }, []);

  return (
    <div className='welcome-template d-flex'>
      <div className='flex-grow-1 me-3'>
        <div
          className='template-canvas'
          ref={canvasRef}
          onClick={handleCanvasClick}
          onDragOver={!isReadOnly ? onCanvasDragOver : undefined}
          onDragLeave={!isReadOnly ? onCanvasDragLeave : undefined}
          onDrop={!isReadOnly ? onCanvasDrop : undefined}
          style={{
            fontFamily: bodySettings.fontFamily,
            fontWeight: getFontWeightValue(bodySettings.fontWeight),
            color: bodySettings.textColor,
            position: 'relative',
            backgroundColor: bodySettings.backgroundColor,
          }}
        >
          {bodySettings.backgroundVideo && isAllowedVideoUrl(bodySettings.backgroundVideo) &&
            (() => {
              const src = bodySettings.backgroundVideo;
              const bgYtId = getYouTubeVideoId(src);
              if (bgYtId) {
                const vid = bgYtId;
                const params = new URLSearchParams();
                params.set('autoplay', '1');
                params.set('mute', '1');
                params.set('loop', '1');
                params.set('playlist', vid);
                const embedUrl = `https://www.youtube-nocookie.com/embed/${vid}?${params.toString()}&rel=0&enablejsapi=1`;
                return (
                  <iframe
                    src={embedUrl}
                    className='bg-video'
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      zIndex: 0,
                      pointerEvents: 'none',
                    }}
                    frameBorder='0'
                    allow='accelerometer; autoplay; clipboard-write; encrypted-media; picture-in-picture'
                    allowFullScreen
                    title='background-video'
                    onLoad={(e) => {
                      try {
                        e.target.contentWindow.postMessage(JSON.stringify({ event: 'listening' }), '*');
                      } catch (err) {}
                    }}
                  />
                );
              }

              const vMatch = src.match(/vimeo\.com\/(?:video\/)?(\d+)/);
              if (vMatch) {
                const vid = vMatch[1];
                const params = new URLSearchParams();
                params.set('autoplay', '1');
                params.set('muted', '1');
                params.set('loop', '1');
                const embedUrl = `https://player.vimeo.com/video/${vid}?${params.toString()}`;
                return (
                  <iframe
                    src={embedUrl}
                    className='bg-video'
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      zIndex: 0,
                      pointerEvents: 'none',
                    }}
                    frameBorder='0'
                    allow='autoplay; fullscreen; picture-in-picture'
                    allowFullScreen
                    title='background-video'
                  />
                );
              }

              return (
                <video
                  src={src}
                  autoPlay
                  loop
                  muted
                  className='bg-video'
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    zIndex: 0,
                    pointerEvents: 'none',
                  }}
                />
              );
            })()}

          {bodySettings.backgroundImage && !bodySettings.backgroundVideo && (
            <div
              className='bg-img'
              style={{
                backgroundImage: `url(${bodySettings.backgroundImage})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                zIndex: 0,
                willChange: 'transform',
              }}
            />
          )}

          {canvasItems.map((item) => (
            <div
              key={item.id}
              className={`canvas-item ${item.id === selectedId ? 'selected' : ''}`}
              style={{
                position: 'absolute',
                zIndex: item.id === selectedId ? 1000 : 1,
                top: item.y,
                left: item.x,
                width: item.props.width + 'px',
                height: item.props.height + 'px',
                paddingTop: `${item.props.paddingTop || 0}px`,
                paddingBottom: `${item.props.paddingBottom || 0}px`,
                paddingLeft: `${item.props.paddingLeft || 0}px`,
                paddingRight: `${item.props.paddingRight || 0}px`,
                letterSpacing: `${item.props.letterSpacing || 0}px`,
                overflow: 'visible',
                border: isReadOnly ? 'none' : undefined,
                boxShadow: isReadOnly ? 'none' : undefined,
              }}
              onMouseDown={!isReadOnly ? (e) => handleMouseDown(e, item.id) : undefined}
              onClick={
                !isReadOnly
                  ? (e) => {
                      const editable = e?.target?.closest('[contenteditable="true"]');
                      if (editable) {
                        handleSelect(e, item.id);
                        const range = document?.caretRangeFromPoint
                          ? document?.caretRangeFromPoint(e?.clientX, e?.clientY)
                          : document?.caretPositionFromPoint
                          ? (() => {
                              const pos = document?.caretPositionFromPoint(e?.clientX, e?.clientY);
                              if (!pos) return null;
                              const r = document?.createRange();
                              r?.setStart(pos?.offsetNode, pos?.offset);
                              r?.collapse(true);
                              return r;
                            })()
                          : null;
                        if (range) {
                          const sel = window?.getSelection();
                          sel?.removeAllRanges();
                          sel?.addRange(range);
                        }
                      } else {
                        handleSelect(e, item?.id);
                      }
                    }
                  : undefined
              }
            >
              {!isReadOnly && (
                <>
                  <div
                    className='resize-handle nw'
                    onMouseDown={(e) => handleResizeMouseDown(e, item.id, 'nw')}
                  />
                  <div
                    className='resize-handle ne'
                    onMouseDown={(e) => handleResizeMouseDown(e, item.id, 'ne')}
                  />
                  <div
                    className='resize-handle se'
                    onMouseDown={(e) => handleResizeMouseDown(e, item.id, 'se')}
                  />
                  <div
                    className='resize-handle sw'
                    onMouseDown={(e) => handleResizeMouseDown(e, item.id, 'sw')}
                  />
                </>
              )}
              {!isReadOnly && (
                <div className={`canvas-item-buttons ${getToolbarPosition(item)}`}>
                  <IconButton size='small' className='drag-handle'>
                    <img src={dragIcon} alt='drag' style={{ width: 30 }} />
                  </IconButton>
                  <IconButton
                    size='small'
                    className='delete-button'
                    onClick={() => removeItem(item.id)}
                  >
                    <DeleteForeverIcon fontSize='small' />
                  </IconButton>
                </div>
              )}
              {item.type === 'heading' && (
                <>
                  {React.createElement(`h${item.props.level}`, {
                    ref: (el) => {
                      if (el && el.textContent !== item.props.text) {
                        el.textContent = item.props.text;
                      }
                    },
                    style: {
                      margin: 0,
                      color: item.props.isPlaceholder ? '#999' : item.props.color,
                      fontSize: item.props.fontSize + 'px',
                      fontFamily: item.props.fontFamily,
                      fontWeight: getFontWeightValue(item.props.fontWeight),
                      fontStyle: item.props.fontStyle,
                      textDecoration: item.props.textDecoration,
                      textAlign: item.props.textAlign,
                      display: item.props.listStyleType === 'none' ? 'block' : 'list-item',
                      listStyleType: item.props.listStyleType,
                      paddingLeft: item.props.listStyleType === 'none' ? undefined : '1em',
                      listStylePosition: 'inside',
                      userSelect: isReadOnly ? 'none' : 'text',
                      width: '100%',
                      height: '100%',
                      overflow: 'hidden',
                      wordBreak: 'break-word',
                      overflowWrap: 'break-word',
                      whiteSpace: 'pre-wrap',
                      boxSizing: 'border-box',
                    },
                    contentEditable: !isReadOnly,
                    suppressContentEditableWarning: true,
                    onFocus: () => {
                      if (item.props.isPlaceholder) {
                        updateItemProps({ text: '', isPlaceholder: false }, item?.id);
                      }
                    },
                    onInput: !isReadOnly ? (e) => handleTextInput(e, item) : undefined,
                    onKeyDown: !isReadOnly ? (e) => handleKeyDown(e, item) : undefined,
                  })}
                  {showVariableDropdown && (
                    <VariableDropdown
                      position={variableDropdownPosition}
                      variables={variables}
                      onSelect={(variable) => {
                        const text = item.props.text || '';
                        const newText = text.replace(/\[$/, `${variable.keyword}`);
                        updateItemProps({ text: newText });
                        setShowVariableDropdown(false);
                      }}
                    />
                  )}
                </>
              )}
              {item.type === 'text' && (
                <>
                  <div
                    ref={(el) => {
                      if (el && el.textContent !== item.props.text) {
                        el.textContent = item.props.text;
                      }
                    }}
                    style={{
                      margin: 0,
                      color: item.props.isPlaceholder ? '#999' : item.props.color,
                      fontSize: item.props.fontSize + 'px',
                      fontFamily: item.props.fontFamily,
                      fontWeight: getFontWeightValue(item.props.fontWeight),
                      fontStyle: item.props.fontStyle,
                      textDecoration: item.props.textDecoration,
                      textAlign: item.props.textAlign,
                      display: item.props.listStyleType === 'none' ? 'block' : 'list-item',
                      listStyleType: item.props.listStyleType,
                      paddingLeft: item.props.listStyleType === 'none' ? undefined : '1em',
                      listStylePosition: 'inside',
                      userSelect: isReadOnly ? 'none' : 'text',
                      width: '100%',
                      height: '100%',
                      overflow: 'hidden',
                      wordBreak: 'break-word',
                      overflowWrap: 'break-word',
                      whiteSpace: 'pre-wrap',
                      boxSizing: 'border-box',
                    }}
                    contentEditable={!isReadOnly}
                    suppressContentEditableWarning={true}
                    onFocus={() => {
                      if (item.props.isPlaceholder) {
                        updateItemProps({ text: '', isPlaceholder: false }, item?.id);
                      }
                    }}
                    onInput={!isReadOnly ? (e) => handleTextInput(e, item) : undefined}
                    onKeyDown={!isReadOnly ? (e) => handleKeyDown(e, item) : undefined}
                  />
                  {showVariableDropdown && (
                    <VariableDropdown
                      position={variableDropdownPosition}
                      variables={variables}
                      onSelect={(variable) => {
                        const text = item?.props?.text || '';
                        const newText = text.replace(/\[$/, `${variable?.keyword}`);
                        updateItemProps({ text: newText });
                        setShowVariableDropdown(false);
                      }}
                    />
                  )}
                </>
              )}
              {item.type === 'image' && (
                <div
                  className='canvas-image-container'
                  onDrop={onImageDrop}
                  onDragOver={(e) => e.preventDefault()}
                  style={{
                    width: '100%',
                    height: '100%',
                    backgroundColor: item.props.bgColor || 'transparent',
                    display: 'flex',
                    justifyContent:
                      item.props.align === 'left'
                        ? 'flex-start'
                        : item.props.align === 'right'
                        ? 'flex-end'
                        : 'center',
                    alignItems: 'center',
                    overflow: 'hidden',
                  }}
                >
                  {item.props.src ? (
                    <img
                      src={item.props.src}
                      alt=''
                      style={{
                        maxWidth: '100%',
                        maxHeight: '100%',
                        width:
                          item.props.mode === 'fixed'
                            ? `${item?.props?.imageWidth || item?.props?.width}px`
                            : item?.props?.mode === 'fit'
                            ? 'auto'
                            : '100%',
                        height:
                          item.props.mode === 'fixed'
                            ? `${item?.props?.imageHeight || item?.props?.height}px`
                            : item?.props?.mode === 'fit'
                            ? 'auto'
                            : '100%',
                        objectFit:
                          item.props.mode === 'fixed'
                            ? item.props.imageWidth === 0 && item.props.imageHeight === 0
                              ? 'contain'
                              : 'fill'
                            : item.props.mode === 'fit'
                            ? 'contain'
                            : 'cover',
                        minWidth: '20px',
                        minHeight: '20px',
                      }}
                      onError={(e) => {
                        e.currentTarget.style.display = 'none';
                      }}
                    />
                  ) : (
                    <div className='image-placeholder'>
                      <img
                        src={image_placeholder}
                        alt='Placeholder'
                        style={{ width: 76, height: 76 }}
                      />
                      <input
                        type='file'
                        id={`imageUpload-${item.id}`}
                        accept='image/png ,image/jpeg'
                        onChange={onImageBrowse}
                        style={{ display: 'none' }}
                      />
                      <span
                        className='browse-link'
                        onClick={() => document.getElementById(`imageUpload-${item.id}`).click()}
                      ></span>
                    </div>
                  )}
                </div>
              )}
              {item.type === 'video' && (
                <div className='video-clipper'>
                  {item.props.isPlaying ? (
                    (() => {
                      const idx = item.props.currentIndex || 0;
                      const list = item.props.videoList || [];
                      const videoSrc = list[idx]?.src || item.props.src || '';
                      const compYtId = getYouTubeVideoId(videoSrc);
                      if (compYtId) {
                        const vid = compYtId;
                        const params = new URLSearchParams();
                        if (item.props.playback === 'autoplay') {
                          params.set('autoplay', '1');
                          params.set('mute', '1');
                        }
                        if (item.props.playback === 'loop' && item.props.loopType === 'always') {
                          params.set('loop', '1');
                          params.set('playlist', vid);
                        }
                        const embedUrl = `https://www.youtube-nocookie.com/embed/${vid}?${params.toString()}&rel=0&enablejsapi=1`;
                        return (
                          <iframe
                            data-yt-item-id={item.id}
                            src={embedUrl}
                            width={item.props.width}
                            height={item.props.height}
                            frameBorder='0'
                            allow='accelerometer; autoplay; clipboard-write; encrypted-media; picture-in-picture'
                            allowFullScreen
                            title='video-player'
                            style={{ display: 'block' }}
                            onLoad={(e) => {
                              try {
                                e.target.contentWindow.postMessage(JSON.stringify({ event: 'listening' }), '*');
                              } catch (err) {}
                            }}
                          />
                        );
                      }

                      const vMatch = videoSrc.match(/vimeo\.com\/(?:video\/)?(\d+)/);
                      if (vMatch) {
                        const vid = vMatch[1];
                        const params = new URLSearchParams({ controls: '1' });
                        if (item.props.playback === 'autoplay') {
                          params.set('autoplay', '1');
                          params.set('muted', '1');
                        }
                        if (item.props.playback === 'loop') {
                          params.set('loop', '1');
                        }
                        const embedUrl = `https://player.vimeo.com/video/${vid}?${params.toString()}`;
                        return (
                          <iframe
                            src={embedUrl}
                            width={item.props.width}
                            height={item.props.height}
                            frameBorder='0'
                            allow='autoplay; fullscreen; picture-in-picture'
                            allowFullScreen
                            title='video-player'
                            style={{ display: 'block' }}
                          />
                        );
                      }

                      return (
                        <video
                          loop={item.props.playback === 'loop' && item.props.loopType === 'always'}
                          key={`${item.id}-${idx}-${item.props.videoList[idx]?.loopCount}`}
                          src={videoSrc}
                          controls
                          autoPlay
                          ref={(el) => {
                            if (el) el.__count = 0;
                            {
                            }
                          }}
                          onEnded={(e) => {
                            const videoEl = e?.currentTarget;
                            if (
                              item?.props?.playback === 'loop' &&
                              item?.props?.loopType === 'always'
                            ) {
                              return videoEl?.play();
                            }
                            const {
                              loopType,
                              sequenceMode,
                              videoList,
                              currentIndex = 0,
                            } = item?.props;

                            if (videoList?.length === 0) {
                              if (loopType === 'always') {
                                videoEl.currentTime = 0;
                                videoEl?.play();
                                return;
                              }
                              if (loopType === 'count') {
                                const target = item?.props?.loopCount || 1;
                                videoEl.__count = (videoEl?.__count || 0) + 1;
                                if (videoEl?.__count < target) {
                                  videoEl?.play();
                                } else {
                                  addHistory((items) =>
                                    items.map((i) =>
                                      i?.id === item?.id
                                        ? { ...i, props: { ...i.props, isPlaying: false } }
                                        : i,
                                    ),
                                  );
                                }
                                return;
                              }

                              addHistory((items) =>
                                items.map((i) =>
                                  i?.id === item?.id
                                    ? { ...i, props: { ...i?.props, isPlaying: false } }
                                    : i,
                                ),
                              );
                              return;
                            }

                            if (loopType === 'count') {
                              const target = videoList[currentIndex]?.loopCount || 1;
                              videoEl.__count = (videoEl?.__count || 0) + 1;
                              if (videoEl?.__count < target) {
                                return videoEl?.play();
                              }
                            }

                            let nextIndex = loopType === 'count' ? currentIndex + 1 : currentIndex;

                            if (nextIndex >= videoList?.length) {
                              if (sequenceMode === 'loopAgain') {
                                nextIndex = 0;
                              } else {
                                return addHistory((items) =>
                                  items.map((i) =>
                                    i?.id === item?.id
                                      ? {
                                          ...i,
                                          props: {
                                            ...i?.props,
                                            isPlaying: false,
                                          },
                                        }
                                      : i,
                                  ),
                                );
                              }
                            }

                            const nextSrc = videoList[nextIndex]?.src;

                            if (nextIndex === currentIndex) {
                              videoEl.__count = 0;
                              videoEl.currentTime = 0;
                              return videoEl?.play();
                            }

                            addHistory((items) =>
                              items.map((i) =>
                                i?.id === item?.id
                                  ? {
                                      ...i,
                                      props: {
                                        ...i.props,
                                        src: nextSrc,
                                        currentIndex: nextIndex,
                                        isPlaying: true,
                                      },
                                    }
                                  : i,
                              ),
                            );
                          }}
                          style={{ width: item?.props?.width, height: item?.props?.height }}
                        />
                      );
                    })()
                  ) : (
                    <div
                      style={{
                        width: item.props.width,
                        height: item.props.height,
                        position: 'relative',
                        backgroundColor: 'transparent',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        overflow: 'hidden',
                      }}
                    >
                      {item?.props?.thumbnail &&
                      (item?.props?.playback === 'playOnce' ||
                        (item?.props?.playback === 'loop' &&
                          item?.props?.sequenceMode === 'oneTime')) ? (
                        <img
                          src={item.props.thumbnail}
                          alt='thumbnail'
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                          }}
                        />
                      ) : (
                        <video
                          src={item?.props?.src}
                          muted
                          preload='metadata'
                          style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                          }}
                        />
                      )}

                      <IconButton
                        onClick={() => {
                          const list = item?.props?.videoList || [];
                          const firstSrc = list[0]?.src || item?.props?.src;
                          addHistory((items) =>
                            items.map((i) =>
                              i?.id === item?.id
                                ? {
                                    ...i,
                                    props: {
                                      ...i?.props,
                                      isPlaying: true,
                                      currentIndex: 0,
                                      src: firstSrc,
                                    },
                                  }
                                : i,
                            ),
                          );
                        }}
                        style={{
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          transform: 'translate(-50%,-50%)',
                        }}
                      >
                        <img src={video_placeholder} alt='Play' style={{ width: 79, height: 79 }} />
                      </IconButton>
                    </div>
                  )}
                </div>
              )}

              {selectedId === item.id &&
                !isReadOnly &&
                item.type !== 'image' &&
                item.type !== 'video' &&
                (() => {
                  const pos = getInlineToolbarPosition(item);
                  return (
                    <div
                      ref={inlineToolbarRef}
                      className={`inline-toolbar ${pos.replace(' ', ' ')}`}
                    >
                      <div className='toolbar-row'>
                        <select
                          value={item.props.fontFamily}
                          onChange={(e) => updateItemProps({ fontFamily: e.target.value })}
                          onClick={(e) => e.stopPropagation()}
                          onMouseDown={(e) => e.stopPropagation()}
                          className='inline-dropdown'
                          style={{ width: '100px' }}
                        >
                          {FONT_FAMILIES.map((f) => (
                            <option
                              key={f}
                              value={f}
                              className={
                                f === item.props.fontFamily ? 'dropdown-option-active' : ''
                              }
                            >
                              {f}
                            </option>
                          ))}
                        </select>
                        <select
                          value={item.props.fontSize}
                          onChange={(e) => {
                            const fontSize = +e.target.value;
                            const newLevel = FONT_SIZE_TO_HEADING[fontSize] || item.props.level;
                            updateItemProps({
                              fontSize,
                              level: newLevel,
                              headingType: 'H' + newLevel,
                            });
                          }}
                          onClick={(e) => e.stopPropagation()}
                          onMouseDown={(e) => e.stopPropagation()}
                          className='inline-dropdown'
                        >
                          {FONT_SIZES.map((s) => (
                            <option
                              key={s}
                              value={s}
                              className={s === item.props.fontSize ? 'dropdown-option-active' : ''}
                            >
                              {s}px
                            </option>
                          ))}
                        </select>
                        <div className='separator' />
                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            toggleStyle('fontWeight');
                          }}
                          className={item.props.fontWeight === 'Bold' ? 'active' : ''}
                        >
                          <FormatBoldIcon />
                        </button>
                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            toggleStyle('fontStyle');
                          }}
                          className={item.props.fontStyle === 'italic' ? 'active' : ''}
                        >
                          <FormatItalicIcon />
                        </button>
                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            toggleStyle('textDecoration');
                          }}
                          className={
                            item.props.textDecoration?.includes('underline') ? 'active' : ''
                          }
                        >
                          <FormatUnderlinedIcon />
                        </button>
                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            toggleStyle('textStrike');
                          }}
                          className={
                            item.props.textDecoration?.includes('line-through') ? 'active' : ''
                          }
                        >
                          <StrikethroughSIcon />
                        </button>
                        <div className='separator' />
                        <button onClick={toggleToolbar}>
                          <CloseFullscreen />
                        </button>
                      </div>
                      {!toolbarCollapsed && (
                        <div className='toolbar-row'>
                          <button
                            className={item.props.textAlign === 'left' ? 'active' : ''}
                            onClick={(e) => {
                              e.preventDefault();
                              applyAlign('left');
                            }}
                          >
                            <FormatAlignLeftIcon />
                          </button>
                          <button
                            className={item.props.textAlign === 'center' ? 'active' : ''}
                            onClick={(e) => {
                              e.preventDefault();
                              applyAlign('center');
                            }}
                          >
                            <FormatAlignCenterIcon />
                          </button>
                          <button
                            className={item.props.textAlign === 'right' ? 'active' : ''}
                            onClick={(e) => {
                              e.preventDefault();
                              applyAlign('right');
                            }}
                          >
                            <FormatAlignRightIcon />
                          </button>
                          <button
                            className={item.props.textAlign === 'justify' ? 'active' : ''}
                            onClick={(e) => {
                              e.preventDefault();
                              applyAlign('justify');
                            }}
                          >
                            <FormatAlignJustifyIcon />
                          </button>
                          <div className='separator' />
                          {/* This feature is temporarily disabled */}
                          {/* <button
                            className={item.props.listStyleType === 'decimal' ? 'active' : ''}
                            onClick={(e) => {
                              e.preventDefault();
                              applyList('decimal');
                            }}
                          >
                            <FormatListNumberedIcon />
                          </button>
                          <div className='separator' /> */}
                        </div>
                      )}
                    </div>
                  );
                })()}
            </div>
          ))}

          {!canvasItems?.length &&
            !bodySettings.backgroundImage &&
            !bodySettings.backgroundVideo && (
              <div className='template-placeholder'>
                <img src={addIcon} alt='Add' style={{ width: 30 }} />
                <div className='mt-3'>Drag & drop components here</div>
              </div>
            )}
        </div>
        <div className='mt-4 save'>
          <Button
            variant='contained'
            color='primary'
            onClick={async (e) => {
              if (templateEditing) {
                await onSaveClick(e);
              } else {
                setTemplateEditing(true);
              }
            }}
            disabled={
              templateEditing &&
              (isTabInValid ||
                hasEmptyMedia ||
                hasEmptyVideoBlock ||
                hasEmptyVideoUrl ||
                hasInvalidText ||
                canvasItems?.length === 0 ||
                hasAnyDuplicateVideo)
            }
          >
            {templateEditing ? 'Save' : 'Edit'}
          </Button>
        </div>
      </div>

      <div className='components-container'>
        {' '}
        {selectedId && canvasItems.find((i) => i.id === selectedId) ? (
          <>
            <div className='editor-header'>
              <h5 className='edit-text mt-4'>
                Edit{' '}
                {canvasItems
                  ?.find((i) => i?.id === selectedId)
                  ?.type?.charAt(0)
                  ?.toUpperCase() + canvasItems?.find((i) => i?.id === selectedId)?.type?.slice(1)}
              </h5>
              <IconButton
                className='close-icon'
                style={{ color: 'white' }}
                onClick={() => setSelectedId(null)}
              >
                <CloseIcon className='close-icon' style={{ color: 'white' }} />
              </IconButton>
            </div>
            {renderEditorPanel()}
          </>
        ) : (
          <>
            <div className='tools-header d-flex mb-3'>
              <div
                className={`tool-toggle flex-fill text-center ${
                  !selectedId && activeTab === 'components' ? 'active' : ''
                } ${isReadOnly ? 'disabled' : ''}`}
                onClick={() => {
                  if (isReadOnly) return;
                  setActiveTab('components');
                  setSelectedId(null);
                }}
              >
                <img src={componentsIcon} className='tool-icon me-2' alt='Components' /> Components
              </div>
              <div
                className={`tool-toggle flex-fill text-center ${
                  !selectedId && activeTab === 'body' ? 'active' : ''
                }`}
                onClick={() => {
                  if (isReadOnly) return;
                  setActiveTab('body');
                  setSelectedId(null);
                }}
              >
                <img src={bodyIcon} className='tool-icon body-icon' alt='Body' /> Body
              </div>
            </div>
            {activeTab === 'components' ? renderComponentsPanel() : renderBodyPanel()}
          </>
        )}
      </div>
    </div>
  );
});

export default WelcomeMessageTemplate;
